"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[367],{

/***/ 2300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ API; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__);








var API = /*#__PURE__*/ function() {
    "use strict";
    function API(options) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, API);
        this.baseUrl = (options === null || options === void 0 ? void 0 : options.baseUrl) || "";
        var _this = this;
        var _this1 = this;
        var _this2 = this;
        var _this3 = this;
        this.public = {
            get: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
                    var _url, url, rest, results, errors;
                    return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _ctx.prev = 1;
                                if (rest.query) {
                                    url += "?".concat(_this.objectToQueryString(rest.query));
                                }
                                _ctx.next = 5;
                                return fetch(_this.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                    method: "get"
                                }, rest));
                            case 5:
                                results = _ctx.sent;
                                return _ctx.abrupt("return", results.json());
                            case 9:
                                _ctx.prev = 9;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_ctx.t0.code === 422) {
                                    errors = Object.values((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.errors) || []);
                                    errors.map(function(error) {
                                        return console.error(error.join(", "));
                                    });
                                } else {
                                    console.error(_ctx.t0.message);
                                }
                            case 12:
                                return _ctx.abrupt("return", null);
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            9
                        ]
                    ]);
                }));
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }(),
            post: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param, parentOptions) {
                    var _url, url, rest, data, isFormData, body, config, headers, results, errors;
                    return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _ctx.prev = 1;
                                data = rest.data ? rest.data : rest;
                                isFormData = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rest.data, FormData);
                                ;
                                config = rest.config ? rest.config : {};
                                if (isFormData) {
                                    headers = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default()(config.headers || {});
                                    headers["Content-Type"] = "multipart/form-data";
                                    config.headers = headers;
                                    body = rest.data;
                                } else {
                                    body = JSON.stringify(data);
                                }
                                _ctx.next = 9;
                                return fetch(_this1.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                    method: "post"
                                }, rest), {
                                    body: body
                                }), config));
                            case 9:
                                results = _ctx.sent;
                                return _ctx.abrupt("return", results.json());
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](1);
                                if (parentOptions === null || parentOptions === void 0 ? void 0 : parentOptions.turnOffToastError) {
                                    _ctx.next = 19;
                                    break;
                                }
                                {
                                    if (_ctx.t0.code === 422) {
                                        errors = Object.values((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.errors) || []);
                                        errors.map(function(error) {
                                            return console.error(error.join(", "));
                                        });
                                    } else {
                                        console.error(_ctx.t0.message);
                                    }
                                }
                                _ctx.next = 20;
                                break;
                            case 19:
                                return _ctx.abrupt("return", _ctx.t0);
                            case 20:
                                return _ctx.abrupt("return", null);
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                return function(_param, parentOptions) {
                    return _ref.apply(this, arguments);
                };
            }(),
            put: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
                    var _url, url, rest, results, errors;
                    return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _ctx.prev = 1;
                                _ctx.next = 4;
                                return fetch(_this2.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                    method: "put"
                                }, rest, rest.data ? {
                                    body: JSON.stringify(rest.data)
                                } : {
                                    body: JSON.stringify(rest)
                                }, rest.config ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest.config) : {}));
                            case 4:
                                results = _ctx.sent;
                                return _ctx.abrupt("return", results.json());
                            case 8:
                                _ctx.prev = 8;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_ctx.t0.code === 422) {
                                    errors = Object.values((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.errors) || []);
                                    errors.map(function(error) {
                                        return console.error(error.join(", "));
                                    });
                                } else {
                                    console.error(_ctx.t0.message);
                                }
                            case 11:
                                return _ctx.abrupt("return", null);
                            case 12:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            8
                        ]
                    ]);
                }));
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delete: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
                    var _url, url, rest, results, errors;
                    return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _ctx.prev = 1;
                                _ctx.next = 4;
                                return fetch(_this3.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                    method: "delete"
                                }, rest));
                            case 4:
                                results = _ctx.sent;
                                return _ctx.abrupt("return", results.json());
                            case 8:
                                _ctx.prev = 8;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_ctx.t0.code === 422) {
                                    errors = Object.values((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.errors) || []);
                                    errors.map(function(error) {
                                        return console.error(error.join(", "));
                                    });
                                } else {
                                    console.error(_ctx.t0.message);
                                }
                            case 11:
                                return _ctx.abrupt("return", null);
                            case 12:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            8
                        ]
                    ]);
                }));
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }()
        };
    }
    var _proto = API.prototype;
    // eslint-disable-next-line class-methods-use-this
    _proto.objectToQueryString = function objectToQueryString(obj) {
        return Object.keys(obj).map(function(key) {
            return "".concat(key, "=").concat(obj[key]);
        }).join("&");
    };
    return API;
}();



/***/ }),

/***/ 80250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var _API__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2300);







var TreedisPublicDAO = /*#__PURE__*/ function(API) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(TreedisPublicDAO, API);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(TreedisPublicDAO);
    function TreedisPublicDAO() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, TreedisPublicDAO);
        var _this;
        _this = _super.call(this);
        var parent = _this.public;
        _this.public = {
            getUser: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "public/getUserIdByDomain"
                }, options));
            },
            getMinimaps: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "public/getMinimaps"
                }, options));
            },
            sendEmail: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/sendEmail"
                }, options));
            },
            getGroups: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getSweepGroups"
                }, options));
            },
            getDuplicates: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getDuplicates/".concat(id)
                }, options));
            },
            getReels: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getReels/".concat(id)
                }, options));
            },
            getTranslations: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTranslations/".concat(id)
                }, options));
            },
            getAgents: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getAgents/".concat(id)
                }, options));
            },
            getEmails: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getEmails/".concat(id)
                }, options));
            },
            getTags: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTags"
                }, options));
            },
            getProducts: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products"
                }, options));
            },
            getProduct: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/get"
                }, options));
            },
            getVariantsByTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/variants/byTour"
                }, options));
            },
            getMediaByTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/medias/byTour"
                }, options));
            },
            getLocationsByTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/locations"
                }, options));
            },
            createHavellsCart: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/havells/cart/create"
                }, options));
            },
            addToHavellsCart: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parentOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/havells/cart/add"
                }, options), parentOptions);
            },
            updateHavellsCart: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/havells/cart/update"
                }, options));
            },
            guestLogin: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/conference/auth/login"
                }, options));
            },
            getConferenceByToken: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/conference/getByToken"
                }, options));
            },
            getConferenceRegisterFields: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/conference/auth/getRegisterFields"
                }, options));
            },
            getTwilioToken: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/video/token"
                }, options));
            },
            guestRegister: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/conference/auth/register"
                }, options));
            },
            getGame: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getGame/"
                }, options));
            },
            getTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTour"
                }, options));
            },
            getTourBySlug: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTourBySlug"
                }, options));
            },
            getAgentsAndTheirSlotsFromClientId: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getAgentsAndTheirSlotsFromClientId"
                }, options));
            },
            getTicketingDiscount: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTicketingDiscount"
                }, options));
            },
            finishOrderTickets: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/finishOrderTickets"
                }, options));
            },
            payTickets: function(paymentType) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticket/payment/".concat(paymentType)
                }, options));
            },
            createTicketOrder: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticket/createOrder"
                }, options));
            },
            ticketLogin: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parentOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticketLogin"
                }, options), parentOptions);
            },
            logoutTicket: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parentOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticketLogout"
                }, options), parentOptions);
            },
            ticketSettings: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticket/settings"
                }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                    query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                        tourId: tourId
                    })
                })));
            },
            getFloorPlans: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getFloorPlans"
                }, options));
            },
            getSweeps: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getSweeps"
                }, options));
            },
            getSweepIndex: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getSweepIndex"
                }, options));
            },
            getVimeoVideo: function(videoId, clientId) {
                return parent.get({
                    url: "v1/public/vimeo",
                    query: {
                        clientId: clientId,
                        path: "/videos/".concat(videoId, "?fields=uri,play,width,height,live,description,title")
                    }
                });
            },
            // @ts-ignore
            getVimeoVideoUrl: function(url) {
                return fetch(url, {
                    method: "HEAD",
                    ignoreInterceptor: true
                }).then(function(res) {
                    return res.url;
                });
            },
            getLockByType: function() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getLockByType"
                }, options));
            },
            getExperienceTopScores: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/experience/".concat(id, "/topScores")
                }, options));
            },
            getProductsWithPagination: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/productsFilters"
                }, options));
            },
            getProductsByTag: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/getByTagSid"
                }, options));
            },
            getProductsByPolygon: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/getByPolygonId"
                }, options));
            }
        };
        return _this;
    }
    return TreedisPublicDAO;
}(_API__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
var DAO = new TreedisPublicDAO().public;
/* harmony default export */ __webpack_exports__["Z"] = (DAO);


/***/ }),

/***/ 40803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ EBottomBarActiveItem; }
/* harmony export */ });
var EBottomBarActiveItem;
(function(EBottomBarActiveItem) {
    EBottomBarActiveItem["cart"] = "quickCart";
    EBottomBarActiveItem["favourite"] = "favorites";
    EBottomBarActiveItem["nearestProducts"] = "itemNearMe";
    EBottomBarActiveItem["reels"] = "reel";
})(EBottomBarActiveItem || (EBottomBarActiveItem = {}));


/***/ }),

/***/ 7710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98592);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94556);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12781);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 27px;\n  color: #ea475c;\n  position: absolute;\n  margin-top: 41px;\n  margin-left: 40px;\n  margin-right: 40px;\n  cursor: pointer;\n  z-index: 1;\n  direction: initial;\n\n  @media screen and (max-width: 760px) {\n    display: inline-block;\n    float: initial;\n    width: 100%;\n    margin: 0;\n    padding: 15px 22px 0 22px;\n    position: relative;\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "BackButton__MainWrap",
    componentId: "sc-a9e543e-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "text-align:right;" : "");
});
var BackButton = function(props) {
    var backFunction = props.backFunction, location = props.location;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .translationDataState */ .Jv), _back = ref.back, back = _back === void 0 ? "back" : _back;
    var rtl = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .tourConfigsState */ .Uq).rtl;
    var history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .useHistory */ .k6)();
    var pushBack = function() {
        if (backFunction) {
            backFunction();
        } else {
            var paths = location.pathname.split("/");
            if (paths[paths.length - 1] === "") paths.pop();
            paths.pop();
            history.push(paths.join("/"));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        onClick: pushBack,
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                className: "fas fa-chevron-left"
            }),
            " ",
            back
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .withRouter */ .EN)(BackButton));


/***/ }),

/***/ 73491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BaseLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./components/ticketingNew/components/TourLanguageSelect.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n  padding: 0 5px;\n  line-height: 1.1;\n  font-size: 15px;\n\n  @media screen and (max-width: 760px) {\n    width: 33.33%;\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  color: white;\n  text-transform: uppercase;\n  position: relative;\n  margin: 0 5px;\n\n  div.mainItem {\n    cursor: pointer;\n  }\n\n  div.optionItem {\n    line-height: 1.3;\n    background: transparent;\n    cursor: pointer;\n\n    display: flex;\n    color: white;\n    align-items: center;\n    justify-content: start;\n    margin-bottom: 10px;\n\n    i {\n      font-size: 5px;\n      margin: 5px;\n      text-decoration: initial !important;\n    }\n\n    span {\n      display: block !important;\n    }\n\n    &.active {\n      text-decoration: underline;\n    }\n  }\n\n  div.optionsWrap {\n    position: absolute;\n    //padding: 16px 0 11px 27px;\n    background-color: rgba(44, 44, 44, 0.9);\n    border-radius: 12px;\n    //margin-left: -40px;\n    width: calc(100% + 51px);\n\n    //padding: 20px 3px 10px 10px;\n    padding: 10px 3px 5px 10px;\n    ",
        ";\n\n    left: 0;\n    margin-left: 0;\n    margin-top: 21px;\n  }\n\n  @media screen and (max-width: 760px) {\n    div.optionsWrap {\n      margin-top: 9px;\n      width: 100vw;\n      position: absolute;\n      left: -20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CustomSelectWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TourLanguageSelect__CustomSelectWrap",
    componentId: "sc-81eec9ae-0"
})(_templateObject());
var CustomSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TourLanguageSelect__CustomSelect",
    componentId: "sc-81eec9ae-1"
})(_templateObject1(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding: 10px 10px 5px 3px;right: 0;left: initial;right: -20px;" : "");
});
var TourLanguageSelect = function(props) {
    var tourId = props.tourId;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _current_tour_has_no_language = ref.current_tour_has_no_language, current_tour_has_no_language = _current_tour_has_no_language === void 0 ? "Current tour has no language" : _current_tour_has_no_language, _no_language = ref.no_language, no_language = _no_language === void 0 ? "no language" : _no_language;
    var ref1 = (0,react.useState)(null), duplicates = ref1[0], setDuplicates = ref1[1];
    var ref2 = (0,react.useState)(false), duplicatesIsOpen = ref2[0], setDuplicatesIsOpen = ref2[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var initialDuplicatesRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return TreedisPublicDAO/* default.getDuplicates */.Z.getDuplicates(tourId);
                    case 2:
                        initialDuplicatesRes = _ctx.sent;
                        if (initialDuplicatesRes && initialDuplicatesRes.message.includes("Success")) {
                            setDuplicates(initialDuplicatesRes.duplicates);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, []);
    var getCurrentLanguage = function() {
        var pathnameSplitted = window.location.pathname.split("/");
        return (duplicates || []).find(function(duplicate) {
            return pathnameSplitted.includes(duplicate.slug);
        });
    };
    var isLanguageActive = function(slug) {
        var pathnameSplitted = window.location.pathname.split("/");
        return pathnameSplitted.find(function(p) {
            return p === slug;
        });
    };
    var handleLanguageClick = function(slug) {
        return function() {
            if (!isLanguageActive(slug)) {
                replaceSlug(slug);
                setDuplicatesIsOpen(false);
            }
        };
    };
    var replaceSlug = function(slug) {
        var pathnames = window.location.pathname.split("/");
        pathnames.shift();
        var targetLink = "/".concat(pathnames[0], "/").concat(pathnames[0] === "experience" ? pathnames[1] : slug).concat(pathnames[0] === "experience" ? "/".concat(slug) : "");
        location.replace(window.location.origin + targetLink);
    };
    var currentLanguageObj = getCurrentLanguage();
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return duplicates && duplicates.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomSelectWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "far fa-globe"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomSelect, {
                rtl: rtl,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mainItem",
                        onClick: function() {
                            return setDuplicatesIsOpen(!duplicatesIsOpen);
                        },
                        children: (currentLanguageObj === null || currentLanguageObj === void 0 ? void 0 : currentLanguageObj.language) || (currentLanguageObj === null || currentLanguageObj === void 0 ? void 0 : currentLanguageObj.languageEn) || current_tour_has_no_language
                    }),
                    duplicatesIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "optionsWrap",
                        children: duplicates.map(function(duplicate, num) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("optionItem", isLanguageActive(duplicate.slug) && "active"),
                                onClick: handleLanguageClick(duplicate.slug),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-circle"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (duplicate === null || duplicate === void 0 ? void 0 : duplicate.language) || (duplicate === null || duplicate === void 0 ? void 0 : duplicate.languageEn) || "".concat(no_language, " / ").concat(duplicate.slug)
                                    })
                                ]
                            }, num);
                        })
                    })
                ]
            }),
            duplicatesIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fas fa-chevron-up"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fas fa-chevron-down"
            })
        ]
    }) : null;
};
/* harmony default export */ var components_TourLanguageSelect = (TourLanguageSelect);

;// CONCATENATED MODULE: ./components/ticketingNew/components/BaseLayout.tsx




function BaseLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  margin: auto;\n  background-color: ",
        ";\n  //background: conic-gradient(from 193.61deg at 46.18% 51.15%, #000000 -139.17deg, #eeeeee 10.44deg, #ffffff 157.82deg, #000000 220.83deg, #eeeeee 370.44deg);\n  ",
        ";\n\n  header {\n    height: 58px;\n    width: 100%;\n    background-color: #282828;\n    color: white;\n    display: flex;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n    z-index: 1;\n\n    .bl-header-clientPic {\n      //left: 15px;\n      //position: absolute;\n      //background: #ccadad;\n      width: 100px;\n      height: 100%;\n      margin-right: 15px;\n\n      &.forMobile {\n        display: none;\n      }\n      object-fit: contain;\n\n      @media screen and (max-width: 760px) {\n        display: none;\n        &.forMobile {\n          display: block;\n          order: 2;\n          width: 33.33%;\n          margin: 0;\n        }\n      }\n    }\n\n    .bl-header-block {\n      font-size: 16px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      margin: auto;\n      justify-content: center;\n      height: 100%;\n      width: auto;\n      left: ",
        ";\n      right: ",
        ";\n\n      @media screen and (max-width: 760px) {\n        width: 100%;\n        right: 0;\n        //right: auto;\n        span {\n          display: none;\n        }\n      }\n\n      & > * {\n        line-height: 1;\n      }\n\n      .bl-header-lang {\n        display: flex;\n        align-items: center;\n\n        i {\n          font-size: 16px;\n        }\n\n        select {\n          line-height: 1;\n          background: transparent;\n          color: white;\n          font-size: 16px;\n          padding: 0;\n          min-width: 43px;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 1;\n          width: 33.33%;\n          padding-left: 15px;\n        }\n      }\n\n      .loginButton-wrap {\n        .signButton {\n          border: 1.5px solid #ffffff;\n          box-sizing: border-box;\n          filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n          border-radius: 6px;\n          width: 83px;\n          height: 31px;\n          background: transparent;\n          color: white;\n          margin: 0 15px;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 3;\n          margin: 0;\n          text-align: right;\n          width: 33.33%;\n          padding-right: 15px;\n          button {\n            margin: 0 !important;\n          }\n        }\n      }\n\n      .buyNowLink {\n        margin: 0 15px;\n        text-decoration: underline;\n\n        &:hover,\n        &:active {\n          color: white;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 3;\n          width: 33.33%;\n          text-align: right;\n          margin: 0;\n          padding-right: 15px;\n        }\n      }\n    }\n  }\n\n  .bl-inner-content {\n    min-height: calc(100vh - 155px);\n    overflow: hidden;\n  }\n\n  footer {\n    height: 97px;\n    width: 100%;\n    background-color: #282828;\n    color: white;\n    margin-top: 35px;\n\n    .bl-footer-copyright {\n      height: 45px;\n      margin: 30px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      font-size: 22px;\n\n      span {\n        margin: 0 15px 0 5px;\n      }\n\n      img {\n        margin-top: 3px;\n        margin-left: 5px;\n        width: 101px;\n        object-fit: contain;\n        height: 46px;\n\n        &[alt='treedis'] {\n          filter: brightness(0) saturate(100%) invert(45%) sepia(15%) saturate(3730%) hue-rotate(311deg) brightness(90%) contrast(105%);\n        }\n      }\n    }\n  }\n"
    ]);
    BaseLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var BaseLayoutStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BaseLayout__BaseLayoutStyled",
    componentId: "sc-528ea9ef-0"
})(BaseLayout_templateObject(), function(p) {
    return p.transparentBg ? "#E5E5E528" : "#e5e5e5";
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "direction: rtl; text-align: right;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "50px" : "initial");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "initial" : "50px");
});
var ClientPic = function(param) {
    var _forMobile = param.forMobile, forMobile = _forMobile === void 0 ? false : _forMobile, _src = param.src, src = _src === void 0 ? "" : _src;
    return src ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: src,
        alt: "client_logo",
        className: classnames_default()("bl-header-clientPic", forMobile && "forMobile")
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("bl-header-clientPic", forMobile && "forMobile")
    });
};
var BaseLayout = function(props) {
    var ref, ref1;
    var location = props.location, children = props.children, _tourId = props.tourId, tourId = _tourId === void 0 ? 0 : _tourId, _whiteLabelData = props.whiteLabelData, whiteLabelData = _whiteLabelData === void 0 ? {} : _whiteLabelData, _transparentBg = props.transparentBg, transparentBg = _transparentBg === void 0 ? false : _transparentBg;
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    var ref2 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _log_in = ref2.log_in, log_in = _log_in === void 0 ? "log in" : _log_in, _buy_now = ref2.buy_now, buy_now = _buy_now === void 0 ? "Buy now" : _buy_now, _powered_by = ref2.powered_by, powered_by = _powered_by === void 0 ? "Powered by" : _powered_by, _already_have_a_ticket = ref2.already_have_a_ticket, already_have_a_ticket = _already_have_a_ticket === void 0 ? "Already have a ticket?" : _already_have_a_ticket, _dont_have_a_tour_ticket = ref2.dont_have_a_tour_ticket, dont_have_a_tour_ticket = _dont_have_a_tour_ticket === void 0 ? "Don't have a tour ticket?" : _dont_have_a_tour_ticket;
    var isLoginPage = location.pathname.includes("login");
    var pathnames = location.pathname.split("/");
    pathnames.shift();
    var homeLink = "/".concat(pathnames[0], "/").concat(pathnames[1]).concat(pathnames[0] === "experience" ? "/".concat(pathnames[2]) : "", "/book");
    var loginLink = "/".concat(pathnames[0], "/").concat(pathnames[1]).concat(pathnames[0] === "experience" ? "/".concat(pathnames[2]) : "", "/login");
    var clietnLogoSrc = whiteLabelData.logo && (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : (ref = whiteLabelData.logo) === null || ref === void 0 ? void 0 : ref.includes("clients")) ? whiteLabelData.logo : "";
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref3[0], setInfoModalData = ref3[1];
    var closeInfoModal = function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayoutStyled, {
        transparentBg: transparentBg,
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientPic, {
                        src: clietnLogoSrc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-header-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientPic, {
                                forMobile: true,
                                src: clietnLogoSrc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: !isLoginPage ? already_have_a_ticket : dont_have_a_tour_ticket
                            }),
                            isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: homeLink,
                                className: "buyNowLink",
                                onClick: closeInfoModal,
                                children: buy_now
                            }),
                            !isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: loginLink,
                                className: "loginButton-wrap",
                                onClick: closeInfoModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "signButton",
                                    children: log_in
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TourLanguageSelect, {
                                tourId: tourId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-inner-content",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bl-footer-copyright",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "far fa-copyright"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: powered_by
                        }),
                        whiteLabelData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : (ref1 = whiteLabelData.domainUrl) === null || ref1 === void 0 ? void 0 : ref1.includes("http")) ? whiteLabelData.domainUrl : "http://" + whiteLabelData.domainUrl,
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: whiteLabelData.logo,
                                alt: "whitelabel logo"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://treedis.com/",
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "treedis",
                                src: "/logo.png",
                                alt: "treedis logo"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_BaseLayout = ((0,react_router/* withRouter */.EN)(BaseLayout));


/***/ }),

/***/ 47887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ EInfoModal; },
  "Z": function() { return /* binding */ components_InfoModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./components/ticketingNew/components/BaseLayout.tsx + 1 modules
var BaseLayout = __webpack_require__(73491);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./components/ticketingNew/components/TicketItemMobile.tsx
var TicketItemMobile = __webpack_require__(47238);
// EXTERNAL MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx + 2 modules
var OrderDetailsBlock = __webpack_require__(61749);
// EXTERNAL MODULE: ./components/ticketingNew/pages/Order/index.tsx + 2 modules
var Order = __webpack_require__(67020);
// EXTERNAL MODULE: ./components/ticketingNew/pages/OrderSuccess.tsx + 1 modules
var OrderSuccess = __webpack_require__(99931);
;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderTicketFromTour/index.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 20px;\n  width: 1162px;\n  max-width: 100%;\n  margin: 44px auto 43px auto;\n  background: rgba(79, 79, 79, 0.6);\n  backdrop-filter: blur(150px);\n  padding: 54px 180px;\n  color: white;\n  position: relative;\n  text-align: center;\n\n  .otft-home {\n    font-weight: 600;\n    font-size: 18px;\n    color: white;\n    text-decoration: none;\n    position: absolute;\n    left: 65px;\n    top: 69px;\n\n    i {\n      margin-right: 5px;\n    }\n  }\n\n  .otft-header {\n    font-weight: 400;\n    font-size: 60px;\n    line-height: 90px;\n    margin-bottom: 10px;\n  }\n\n  .otft-title {\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 33px;\n    margin-bottom: 10px;\n  }\n\n  .otft-message {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 30px;\n    margin-bottom: 40px;\n  }\n\n  .otft-content {\n    display: flex;\n  }\n\n  .otft-tickets {\n    color: black;\n    width: 50%;\n\n    max-height: 435px;\n    overflow-y: scroll;\n    padding-right: 5px;\n  }\n  .otft-payment {\n    text-align: initial;\n    width: 50%;\n\n    .bl-ticket-order {\n      width: 100%;\n      padding: 28px;\n      color: black;\n      margin-left: 15px;\n    }\n\n    .bl-ticket-order-pay-btn {\n      padding: 8px 15px;\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderTicketFromTour__MainWrap",
    componentId: "sc-3101faca-0"
})(_templateObject());
var OrderTicketFromTour = function(props) {
    var location = props.location, _message = props.message, message = _message === void 0 ? "Your ticket time is expired.. but you can buy a new ticket" : _message, match = props.match;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref[0], setInfoModalData = ref[1];
    console.log("infoModalData", infoModalData);
    var ref1 = infoModalData === null || infoModalData === void 0 ? void 0 : infoModalData.ticketLoginData, ticketing = ref1.ticketing, ticketingOrderedTicket = ref1.ticketingOrderedTicket, ticketingTourTicket = ref1.ticketingTourTicket, tour = ref1.tour;
    var participants = [
        {
            id: Date.now(),
            fullName: ticketingOrderedTicket.name,
            email: ticketingOrderedTicket.email,
            isGift: ticketingOrderedTicket.isGift
        }, 
    ];
    var ref2 = (0,react.useState)(null), pickedTicketId = ref2[0], setPickedTicketId = ref2[1];
    var ref3 = (0,react.useState)(""), orderLink = ref3[0], setOrderLink = ref3[1];
    var ref4 = (0,react.useState)(Order/* OrderStageEnum.order */.t9.order), orderStage = ref4[0], setOrderStage = ref4[1];
    var homePage = location.pathname.replace(/book.+|book/g, "");
    var closeInfoModal = function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    var getTicketList = function() {
        //get current orderedTicket data & return tickets of same type (guided, ys, experience)
        //for restriction, return tours that have access to restricted sweep
        if (ticketingOrderedTicket.ticketType === "gameTour") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGameTour;
        else if (ticketingOrderedTicket.ticketType === "tourByYourself") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingToursByYourself;
        else if (ticketingOrderedTicket.ticketType === "guidedTour") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGuidedTour;
        return [];
    };
    //@ts-ignore
    var handlePaymentSuccess = function() {
    //close modal
    //go to login page with inserted ticket id
    };
    var tickets = getTicketList();
    console.log("tickets", tickets);
    console.log("infoModalData", infoModalData);
    if (!tickets || !infoModalData) {
        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            mode: EInfoModal.error,
            message: infoModalData.mode === EInfoModal.timeIsUp ? "Ticket time is up" : "Area is restricted for this tour"
        }));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "closing..."
        });
    }
    console.log("ticketingOrderedTicket", ticketingOrderedTicket);
    console.log("ticketingTourTicket", ticketingTourTicket);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        children: [
            orderStage === Order/* OrderStageEnum.order */.t9.order && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_router_dom/* Link */.rU, {
                        to: homePage,
                        className: "otft-home",
                        onClick: closeInfoModal,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-chevron-left"
                            }),
                            "Home Page"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-header",
                        children: "Oops!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-title",
                        children: message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-message",
                        children: "Pick your new ticket"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "otft-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "otft-tickets",
                                children: tickets === null || tickets === void 0 ? void 0 : tickets.map(function(e) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TicketItemMobile/* default */.Z, {
                                        ticket: e,
                                        currencyId: 3,
                                        onPick: function(id) {
                                            return setPickedTicketId(id);
                                        },
                                        pickedId: pickedTicketId
                                    }, e === null || e === void 0 ? void 0 : e.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "otft-payment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailsBlock/* default */.Z, {
                                    tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                    gameId: tour === null || tour === void 0 ? void 0 : tour.gameId,
                                    matterId: tour === null || tour === void 0 ? void 0 : tour.matterId,
                                    setOrderStage: setOrderStage,
                                    participants: participants,
                                    handlePaymentSuccess: function() {
                                        return setOrderStage(Order/* OrderStageEnum.tourOrderOnlySuccess */.t9.tourOrderOnlySuccess);
                                    },
                                    match: match,
                                    setOrderLink: setOrderLink,
                                    initialTourType: ticketingOrderedTicket === null || ticketingOrderedTicket === void 0 ? void 0 : ticketingOrderedTicket.ticketType,
                                    initialTicketId: pickedTicketId
                                })
                            })
                        ]
                    })
                ]
            }),
            orderStage === Order/* OrderStageEnum.payment */.t9.payment && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "otft-order-frame",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-chevron-left"
                            }),
                            " back"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Payment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Please enter your payment details"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: orderLink
                    })
                ]
            }),
            orderStage === Order/* OrderStageEnum.tourOrderOnlySuccess */.t9.tourOrderOnlySuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSuccess/* default */.Z, {
                minimized: true,
                onLinkClick: closeInfoModal
            })
        ]
    });
};
/* harmony default export */ var components_OrderTicketFromTour = ((0,react_router/* withRouter */.EN)(OrderTicketFromTour));

;// CONCATENATED MODULE: ./components/ticketingNew/components/InfoModal.tsx




function InfoModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  max-width: 100%;\n\n  .im-inner-wrap {\n    background: rgba(79, 79, 79, 0.6);\n    color: white;\n    backdrop-filter: blur(150px);\n    border-radius: 20px;\n    padding: 54px 71px;\n    text-align: center;\n\n    .im-inner-warn {\n      font-weight: 400;\n      font-size: 60px;\n      line-height: 90px;\n      margin-bottom: 10px;\n    }\n\n    .im-inner-title {\n      font-weight: 500;\n      font-size: 22px;\n      line-height: 33px;\n      margin-bottom: 10px;\n    }\n\n    .im-inner-message {\n      font-weight: 400;\n      font-size: 15px;\n      line-height: 22px;\n      margin-bottom: 60px;\n    }\n\n    .im-inner-ok_btn {\n      background-color: #ea475c;\n      border-radius: 12px;\n      color: white;\n      font-weight: 600;\n      font-size: 18px;\n      padding: 15px 34px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\n      &:active {\n        opacity: 0.8;\n      }\n\n      i {\n        margin-left: 5px;\n      }\n    }\n  }\n\n  & > .cVideo-modal-videoWrap {\n    width: 100%;\n    height: 100%;\n\n    & > iframe {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .im-redirect-btn {\n    margin-right: 15px;\n  }\n"
    ]);
    InfoModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledModal = (0,styled_components_browser_esm/* default */.ZP)((lib_default())).withConfig({
    displayName: "InfoModal__StyledModal",
    componentId: "sc-a396d503-0"
})(InfoModal_templateObject(), function(props) {
    return props.mode !== EInfoModal.error ? "100%" : "746px";
}, function(props) {
    return props.mode !== EInfoModal.error ? "auto" : "421px";
});
var EInfoModal;
(function(EInfoModal) {
    EInfoModal[EInfoModal["error"] = 0] = "error";
    EInfoModal[EInfoModal["timeIsUp"] = 1] = "timeIsUp";
    EInfoModal[EInfoModal["restrictedArea"] = 2] = "restrictedArea";
})(EInfoModal || (EInfoModal = {}));
var InfoModal = function(props) {
    var root = props.root;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref[0], setInfoModalData = ref[1];
    var handleClose = infoModalData.onRequestClose ? infoModalData.onRequestClose : function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    var handleCloseRedirect = function() {
        window.location.href = infoModalData === null || infoModalData === void 0 ? void 0 : infoModalData.redirectLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
        isOpen: infoModalData.isOpen,
        onRequestClose: handleClose,
        mode: infoModalData.mode,
        appElement: root,
        children: [
            infoModalData.mode === EInfoModal.error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "im-inner-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-warn",
                        children: "Oops!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-title",
                        children: infoModalData.message || "Ticket not found"
                    }),
                    !infoModalData.message && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-message",
                        children: "You can find your customer code number on the purchase confirmation Email"
                    }),
                    infoModalData.redirectLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "im-inner-ok_btn",
                        onClick: handleCloseRedirect,
                        children: "Proceed to needed page"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "im-inner-ok_btn",
                        onClick: handleClose,
                        children: [
                            "Got it ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-check"
                            })
                        ]
                    })
                ]
            }),
            infoModalData.mode !== EInfoModal.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* default */.Z, {
                transparentBg: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "im-inner-wrap-order",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OrderTicketFromTour, {})
                })
            })
        ]
    });
};
/* harmony default export */ var components_InfoModal = ((0,react_router/* withRouter */.EN)(InfoModal));


/***/ }),

/***/ 72225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12781);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94556);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  //margin-top: 18px;\n\n  @media screen and (max-width: 760px) {\n    margin-top: 9px;\n    max-width: 100%;\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-top: 5px;\n  text-align: center;\n\n  .bl-card-btn {\n    background: #ffffff;\n    border: 1px solid #000000;\n    box-sizing: border-box;\n    box-shadow: -4px 4px 0px rgba(255, 255, 255, 0.25);\n    border-radius: 12px;\n    padding: 8px 22px;\n\n    &:active {\n      opacity: 0.9;\n    }\n  }\n\n  .bl-btn-hr {\n    width: 65px;\n    top: 0px;\n    border-color: black;\n    position: absolute;\n\n    &.bl-hr-left {\n      left: 20px;\n    }\n\n    &.bl-hr-right {\n      right: 20px;\n    }\n\n    @media screen and (max-width: 760px) {\n      width: 20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var BlCardBarcode = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MoreInfoBtn__BlCardBarcode",
    componentId: "sc-1aecdbc6-0"
})(_templateObject());
var BlCardBtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MoreInfoBtn__BlCardBtnWrap",
    componentId: "sc-1aecdbc6-1"
})(_templateObject1());
var MoreInfoBtn = function(param) {
    var ticketInfoUlr = param.ticketInfoUlr;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .translationDataState */ .Jv), _more_info = ref.more_info, more_info = _more_info === void 0 ? "More Info" : _more_info;
    return ticketInfoUlr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlCardBtnWrap, {
        className: "bl-card-btn-wrap",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
            href: ticketInfoUlr.includes("http") ? ticketInfoUlr : "http://".concat(ticketInfoUlr),
            target: "_blank",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    className: "bl-card-btn",
                    children: more_info
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                    className: "bl-btn-hr bl-hr-left"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                    className: "bl-btn-hr bl-hr-right"
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlCardBarcode, {
        className: "bl-card-barcode",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            src: "/ticketing/barcode.png",
            alt: "ticket_barcode"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MoreInfoBtn);


/***/ }),

/***/ 61749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_OrderDetailsBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./components/ticketingNew/components/DiscountField.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-order-discount {\n    margin-top: 13px;\n    cursor: pointer;\n\n    .bl-ticket-order-discount-text {\n      .fa-ticket-alt {\n        margin-right: 5px;\n      }\n\n      .fa-chevron-down {\n        margin-left: 5px;\n      }\n    }\n\n    .bl-ticket-order-discount-input-activate {\n      display: flex;\n      height: 35px;\n      position: relative;\n\n      .bl-discount-input-wrap {\n        display: flex;\n        position: relative;\n        width: 100%;\n\n        .bl-discount-error-icon {\n          background: #ea475c;\n          width: 14px;\n          height: 14px;\n          position: absolute;\n          right: 10px;\n          border-radius: 50%;\n          color: white;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          top: 10px;\n          font-weight: 300;\n          font-size: 12px;\n          ",
        ";\n        }\n\n        .bl-applied-discount-value {\n          position: absolute;\n          font-weight: 300;\n          font-size: 15px;\n          line-height: 21px;\n          display: flex;\n          align-items: center;\n          top: 8px;\n          height: 18px;\n          right: 12px;\n\n          ",
        ";\n\n          .bl-confirmed-icon-wrap {\n            font-weight: 300;\n            line-height: 21px;\n            width: 14px;\n            height: 14px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background: #59df76;\n            border-radius: 50%;\n            margin-left: 6px;\n            color: white;\n            font-size: 8px;\n          }\n        }\n      }\n\n      i.fa-ticket-alt {\n        z-index: 1;\n        position: absolute;\n        top: 10px;\n        left: 8px;\n        ",
        ";\n      }\n\n      input {\n        padding-left: 25px;\n        height: 35px;\n        background: #ffffff;\n        /* Dark/Dark 1 */\n\n        border: 1px solid #b2bcca;\n        box-sizing: border-box;\n        border-radius: 8px;\n        ",
        ";\n\n        &:active,\n        &:focus {\n          outline: 2px solid #b2bcca;\n        }\n\n        &.error {\n          border-color: #ea475c;\n\n          &:active,\n          &:focus {\n            outline: 2px solid #ea475c;\n          }\n        }\n      }\n\n      button {\n        margin-left: 18px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #ea475c;\n        background: transparent;\n        border: 2px solid #ea475c;\n        box-sizing: border-box;\n        border-radius: 12px;\n        padding: 0px 35px;\n        ",
        ";\n\n        &:active {\n          background: rgba(234, 71, 92, 0.1);\n        }\n      }\n\n      &.applied {\n        button {\n          color: white;\n          border: none;\n          background-color: #21d349bf;\n\n          &:active {\n            opacity: 0.9;\n          }\n        }\n      }\n    }\n\n    .bl-discount-error-message {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 20px;\n      color: #ea475c;\n      margin-top: 4px;\n      ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var DiscountMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DiscountField__DiscountMainWrap",
    componentId: "sc-eb5405af-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;position: absolute;left: 8px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;left: 15px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 9px;left: initial;right:8px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding: 8px 30px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin-right: 18px;margin-left: 0;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "text-align: right;direction: rtl;" : "");
});
var DiscountField = function(props) {
    var tourId = props.tourId, ticketId = props.ticketId, ticketingType = props.ticketingType, currencySign = props.currencySign, onDiscountApply = props.onDiscountApply;
    var ref = (0,react.useState)(false), isAbleToSetDiscount = ref[0], setIsAbleToSetDiscount = ref[1];
    var ref1 = (0,react.useState)(""), discountCode = ref1[0], setDiscountCode = ref1[1];
    var ref2 = (0,react.useState)(false), discountLoading = ref2[0], setDiscountLoading = ref2[1];
    var ref3 = (0,react.useState)({}), appliedDiscount = ref3[0], setAppliedDiscount = ref3[1];
    var ref4 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _add_a_gift_card_or_discount_code = ref4.add_a_gift_card_or_discount_code, add_a_gift_card_or_discount_code = _add_a_gift_card_or_discount_code === void 0 ? "Add a gift card or discount code" : _add_a_gift_card_or_discount_code, _apply = ref4.apply, apply = _apply === void 0 ? "Apply" : _apply, _confirmed = ref4.confirmed, confirmed = _confirmed === void 0 ? "Confirmed" : _confirmed, _promocode_not_found = ref4.promocode_not_found, promocode_not_found = _promocode_not_found === void 0 ? "promocode not found" : _promocode_not_found;
    var loadPromocode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var promocodeRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!(!(appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.amount) && tourId)) {
                            _ctx.next = 7;
                            break;
                        }
                        setDiscountLoading(true);
                        _ctx.next = 5;
                        return TreedisPublicDAO/* default.getTicketingDiscount */.Z.getTicketingDiscount({
                            query: {
                                tourId: tourId,
                                codeName: discountCode,
                                ticketId: ticketId,
                                ticketingType: ticketingType
                            }
                        });
                    case 5:
                        promocodeRes = _ctx.sent;
                        if (promocodeRes && promocodeRes.message.includes("Success")) {
                            setAppliedDiscount(promocodeRes.data);
                            onDiscountApply(promocodeRes.data);
                        } else {
                            setAppliedDiscount({
                                error: promocode_not_found
                            });
                        }
                    case 7:
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        setAppliedDiscount({
                            error: _ctx.t0.message
                        });
                    case 12:
                        _ctx.prev = 12;
                        setDiscountLoading(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9,
                    12,
                    15
                ]
            ]);
        }));
        return function loadPromocode() {
            return _ref.apply(this, arguments);
        };
    }();
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountMainWrap, {
        className: "bl-ticket-order-discount",
        rtl: rtl,
        children: [
            !isAbleToSetDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-discount-text",
                onClick: function() {
                    return setIsAbleToSetDiscount(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-ticket-alt"
                    }),
                    " ",
                    add_a_gift_card_or_discount_code,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-chevron-down"
                    })
                ]
            }),
            isAbleToSetDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("bl-ticket-order-discount-input-activate", appliedDiscount.amount && "applied"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-ticket-alt"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-discount-input-wrap",
                        children: [
                            appliedDiscount.amount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-applied-discount-value",
                                children: [
                                    "-",
                                    appliedDiscount.amount,
                                    appliedDiscount.discountType === "percent" ? "%" : currencySign,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-confirmed-icon-wrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fal fa-check"
                                        })
                                    })
                                ]
                            }),
                            appliedDiscount.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-discount-error-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fal fa-times"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: classnames_default()(appliedDiscount.error && "error"),
                                disabled: discountLoading || appliedDiscount.amount,
                                type: "text",
                                value: discountCode,
                                onChange: function(ev) {
                                    return setDiscountCode(ev.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: loadPromocode,
                        children: appliedDiscount.amount ? confirmed : apply
                    })
                ]
            }),
            appliedDiscount.error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-discount-error-message",
                children: [
                    "*",
                    appliedDiscount.error
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DiscountField = (DiscountField);

// EXTERNAL MODULE: ./node_modules/react-paypal-button-v2/lib/index.js
var lib = __webpack_require__(86295);
// EXTERNAL MODULE: ./components/ticketingNew/pages/Order/index.tsx + 2 modules
var Order = __webpack_require__(67020);
// EXTERNAL MODULE: ./components/ticketingNew/types.ts
var types = __webpack_require__(84345);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
// EXTERNAL MODULE: ./components/util/index.ts + 6 modules
var util = __webpack_require__(66870);
// EXTERNAL MODULE: ./components/ticketingNew/static.ts
var ticketingNew_static = __webpack_require__(70712);
;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderDetailsBlock/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-order {\n    width: 50%;\n    display: inline-block;\n    background: #ffffff;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);\n    padding: 26px 50px 0 53px;\n    height: auto;\n    padding-bottom: 34px;\n    align-self: flex-start;\n\n    .bl-ticket-order-title {\n      font-weight: 500;\n      font-size: 20px;\n      line-height: 30px;\n      margin-bottom: 8px;\n    }\n\n    .bl-ticket-order-subTitle {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 18px;\n      margin-bottom: 10px;\n      color: #828282;\n    }\n\n    .bl-ticket-order-pills {\n      margin-bottom: 15px;\n      display: flex;\n      flex-wrap: wrap;\n\n      .bl-ticket-order-pill {\n        display: flex;\n        align-items: center;\n        border: 0.5px solid #d7d7d7;\n        box-sizing: border-box;\n        box-shadow: 0 0.5px 0 1px rgba(0, 0, 0, 0.16);\n        border-radius: 16px;\n        padding: 4px 18px;\n        margin-right: 7px;\n        margin-bottom: 7px;\n\n        img {\n          width: 15px;\n          height: 15px;\n        }\n      }\n    }\n\n    .bl-ticket-order-private-note-wrap {\n      border: 1px solid #d7d7d7;\n      box-sizing: border-box;\n      border-radius: 3px;\n      padding: 10px 12px 4px 20px;\n      position: relative;\n      margin-bottom: 16px;\n\n      .bl-ticket-order-pnote-header {\n        display: inline-block;\n        position: absolute;\n        top: -10px;\n        background-color: white;\n        color: #828282;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 20px;\n        ",
        ";\n      }\n\n      .bl-ticket-order-pnote-content {\n        font-weight: 300;\n        font-size: 12px;\n        line-height: 21px;\n      }\n    }\n\n    .bl-ticket-order-price {\n      display: flex;\n\n      .bl-ticket-order-price-title {\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 22px;\n        white-space: nowrap;\n      }\n\n      .bl-ticket-order-price-line {\n        border-style: dashed;\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n      }\n\n      .bl-ticket-order-price-cost {\n      }\n    }\n\n    .bl-ticket-order-after-disc-line {\n    }\n\n    .bl-ticket-order-gtotal {\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 19px;\n\n      .bl-ticket-order-gtotal-title {\n      }\n\n      .bl-ticket-order-gtotal-price {\n      }\n    }\n\n    .bl-ticket-order-checkboxes {\n      label {\n        display: flex;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        align-items: baseline;\n        margin-bottom: 10px;\n\n        input[type='checkbox'] {\n          margin-right: 8px;\n          line-height: 20px;\n          width: 12px;\n          height: 12px;\n          accent-color: #ea475c;\n          border-radius: 2px;\n          ",
        ";\n        }\n      }\n    }\n\n    .bl-ticket-order-pay-btn {\n      background: linear-gradient(137.27deg, #ea475c 19.41%, #ff6175 65.49%);\n      box-shadow: 0px 4px 4px rgba(14, 53, 191, 0.25);\n      border-radius: 12px;\n      color: #f6f6f6;\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n\n      padding: 12px 109px;\n      margin: auto;\n      display: block;\n      margin-top: 29px;\n\n      &:active {\n        opacity: 0.9;\n      }\n\n      &:disabled {\n        background: #8b8b8b;\n      }\n    }\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MainWrap",
    componentId: "sc-84e67df1-0"
})(styles_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: 26px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 8px;" : "");
});

;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx





















var StripePaymentButton = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9101), __webpack_require__.e(1323)]).then(__webpack_require__.bind(__webpack_require__, 67838));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67838)
            ];
        }
    },
    ssr: false
});
var OrderDetailsBlock = function(props) {
    var participants = props.participants, setOrderLink = props.setOrderLink, setOrderStage = props.setOrderStage, handlePaymentSuccess = props.handlePaymentSuccess, match = props.match, tourId = props.tourId, matterId = props.matterId, initialTourType = props.initialTourType, initialTicketId = props.initialTicketId, gameId = props.gameId;
    var ticketing = (0,store/* useRecoilValue */.sJ)(store/* ticketingDataState */.$W);
    var ticketingGeneral = ticketing.ticketingGeneral;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _plane_name = ref.plane_name, plane_name = _plane_name === void 0 ? "Plane name" : _plane_name, _available_for = ref.available_for, available_for = _available_for === void 0 ? "Available for" : _available_for, _private_note = ref.private_note, private_note = _private_note === void 0 ? "private Note" : _private_note, _ticket = ref.ticket, ticket = _ticket === void 0 ? "ticket" : _ticket, _grand_total = ref.grand_total, grand_total = _grand_total === void 0 ? "Grand Total" : _grand_total, _legal_checkbox_2 = ref.legal_checkbox_2, legal_checkbox_2 = _legal_checkbox_2 === void 0 ? "Legal checkbox 2" : _legal_checkbox_2, _legal_checkbox_1 = ref.legal_checkbox_1, legal_checkbox_1 = _legal_checkbox_1 === void 0 ? "*I agree terms & conditions" : _legal_checkbox_1, _proceed_to_payment = ref.proceed_to_payment, proceed_to_payment = _proceed_to_payment === void 0 ? "Proceed to payment" : _proceed_to_payment, _devices = ref.devices, devices = _devices === void 0 ? "devices" : _devices, _day = ref.day, day = _day === void 0 ? "day" : _day, _days = ref.days, days = _days === void 0 ? "days" : _days, _hour = ref.hour, hour = _hour === void 0 ? "hour" : _hour, _hours = ref.hours, hours = _hours === void 0 ? "hours" : _hours, _min = ref.min, min = _min === void 0 ? "min" : _min, _mins = ref.mins, mins = _mins === void 0 ? "mins" : _mins, _from_purchase = ref.from_purchase, from_purchase = _from_purchase === void 0 ? "from purchase" : _from_purchase, _from_login = ref.from_login, from_login = _from_login === void 0 ? "from login" : _from_login, _max_participants = ref.max_participants, max_participants = _max_participants === void 0 ? "Max. participants" : _max_participants, _tour_language = ref.tour_language, tour_language = _tour_language === void 0 ? "Tour language" : _tour_language, _wrong_discount_val = ref.wrong_discount_val, wrong_discount_val = _wrong_discount_val === void 0 ? "wrong discount value" : _wrong_discount_val, _user = ref.user, user = _user === void 0 ? "user" : _user, _email = ref.email, email = _email === void 0 ? "email" : _email, _name = ref.name, name = _name === void 0 ? "name" : _name, _is_required = ref.is_required, is_required = _is_required === void 0 ? "is required" : _is_required, _is_not_valid = ref.is_not_valid, is_not_valid = _is_not_valid === void 0 ? "is not valid" : _is_not_valid, _check_out = ref.check_out, check_out = _check_out === void 0 ? "Check Out" : _check_out, _tickets_order_was_cancelled = ref.tickets_order_was_cancelled, tickets_order_was_cancelled = _tickets_order_was_cancelled === void 0 ? "Tickets order was cancelled" : _tickets_order_was_cancelled, _tickets_order_error = ref.tickets_order_error, tickets_order_error = _tickets_order_error === void 0 ? "Tickets order error." : _tickets_order_error;
    var ref1 = (0,react.useState)(null), appliedDiscount = ref1[0], setAppliedDiscount = ref1[1];
    //----------- order data fields --------------
    var ref2 = (0,react.useState)(false), checkbox1 = ref2[0], setCheckbox1 = ref2[1];
    var ref3 = (0,react.useState)(false), checkbox2 = ref3[0], setCheckbox2 = ref3[1];
    //----------- order data fields end --------------
    var ref4 = (0,react.useState)(false), ticketOrderSent = ref4[0], setTicketOrderSent = ref4[1];
    //ticketType: "gameTour"
    var tourType = match.params.tourType || (initialTourType === null || initialTourType === void 0 ? void 0 : initialTourType.replace("gameTour", "experienceTour"));
    var ticketId = match.params.ticketId || initialTicketId;
    var tourTypeKey = util/* ticketingTypes */.pb === null || util/* ticketingTypes */.pb === void 0 ? void 0 : util/* ticketingTypes.find */.pb.find(function(tt) {
        return tt.tourType === tourType;
    });
    var ticketingType = tourTypeKey.key;
    var currentTicket = ticketId ? ticketing[tourTypeKey === null || tourTypeKey === void 0 ? void 0 : tourTypeKey.key].find(function(ticket) {
        return ticket.id === parseInt(ticketId);
    }) : null;
    var currencySymbol = ticketingNew_static/* initialCurrency.find */.Z.find(function(cur) {
        return cur.id === ticketingGeneral.currencyId;
    });
    var orderId = (0,react.useRef)(null);
    var orderBtn = (0,react.useRef)(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref5[0], setInfoModalData = ref5[1];
    var setTicketOrderResult = (0,store/* useSetRecoilState */.Zl)(store/* orderedTicketsState */.jF);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* redirectTicketsState */.Sy), 2), redirectTickets = ref6[0], setRedirectTickets = ref6[1];
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var finishOrderRes, ticketsString, tickets;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!redirectTickets) {
                            _ctx.next = 6;
                            break;
                        }
                        console.log("redirectTickets", redirectTickets);
                        _ctx.next = 4;
                        return TreedisPublicDAO/* default.finishOrderTickets */.Z.finishOrderTickets({
                            /// TODO add transaction to validate
                            orderCode: redirectTickets.orderCode,
                            status: redirectTickets.status,
                            pelecardStatusCode: redirectTickets.PelecardStatusCode,
                            matterId: matterId
                        });
                    case 4:
                        finishOrderRes = _ctx.sent;
                        if (finishOrderRes && finishOrderRes.message.includes("Success")) {
                            if (finishOrderRes.status === "success") {
                                ticketsString = redirectTickets.data;
                                if (ticketsString) {
                                    (0,analytic/* sendToGA */.o$)("event", {
                                        eventCategory: "Ticketing",
                                        eventAction: "purchase",
                                        eventLabel: tourType
                                    });
                                    tickets = JSON.parse(ticketsString);
                                    setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, finishOrderRes === null || finishOrderRes === void 0 ? void 0 : finishOrderRes.order), {
                                        tickets: tickets
                                    }));
                                    handlePaymentSuccess();
                                }
                            } else if (finishOrderRes.status === "cancel") {
                                setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                    isOpen: true,
                                    message: tickets_order_was_cancelled,
                                    mode: InfoModal/* EInfoModal.error */.Y.error
                                }));
                            } else if (finishOrderRes.status === "error") {
                                setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                    isOpen: true,
                                    message: "".concat(tickets_order_error, " ").concat(redirectTickets.PelecardStatusCode ? "PelecardStatusCode - ".concat(redirectTickets.PelecardStatusCode) : ""),
                                    mode: InfoModal/* EInfoModal.error */.Y.error
                                }));
                            }
                        }
                    case 6:
                        setRedirectTickets(null);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        redirectTickets
    ]);
    (0,react.useEffect)(function() {
        if (!(ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.paymentType)) {
            setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: "Looks like ticketing payment method not set or missing. Please check ticketing -> Payment API on admin panel"
            }));
        }
    }, []);
    var applyDiscounts = function(value) {
        var result = value;
        if (!appliedDiscount) return result;
        if (appliedDiscount.discountType === "currency") {
            if (appliedDiscount.amount > 0) result -= appliedDiscount.amount;
            else setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: wrong_discount_val,
                mode: InfoModal/* EInfoModal.error */.Y.error
            }));
        } else if (appliedDiscount.discountType === "percent") {
            if (appliedDiscount.amount > 0 && appliedDiscount.amount <= 100) result -= result * appliedDiscount.amount / 100;
            else setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: wrong_discount_val,
                mode: InfoModal/* EInfoModal.error */.Y.error
            }));
        }
        if (result < 0) return 0;
        return result;
    };
    var totalPrice = currentTicket ? parseFloat(applyDiscounts(participants.length * currentTicket.ticketPrice).toFixed(2)) : 0;
    var _validateUsers = function() {
        var noToast = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var errors = [];
        if (ticketingGeneral.legalCheckbox1Required && !checkbox1) errors.push("".concat(legal_checkbox_1, " ").concat(is_required));
        if (ticketingGeneral.legalCheckbox2Required && !checkbox2) errors.push("".concat(legal_checkbox_2, " ").concat(is_required));
        participants.forEach(function(ticket, num) {
            if (!ticket.email.length) {
                errors.push("".concat(user, " ").concat(num + 1, " ").concat(email, " ").concat(is_required));
            } else if (!(0,util_all/* validateEmail */.oH)(ticket.email)) {
                errors.push("".concat(user, " ").concat(num + 1, " ").concat(email, " ").concat(is_not_valid));
            }
            if (!ticket.fullName) errors.push("".concat(user, " ").concat(num + 1, " ").concat(name, " ").concat(is_required));
        });
        if (errors.length) {
            if (!noToast) react_toastify_esm/* toast.error */.Am.error(errors.join("\n"));
            return 1;
        }
        return 0;
    };
    var handleProceedPayment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, body, data, order, ticketPayRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        if (!(orderBtn === null || orderBtn === void 0 ? void 0 : (ref = orderBtn.current) === null || ref === void 0 ? void 0 : ref.disabled)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (!_validateUsers()) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        setTicketOrderSent(true);
                        body = {
                            paymentType: ticketingGeneral.paymentType,
                            ticketType: tourType.replace("experienceTour", "gameTour"),
                            tourId: tourId,
                            matterId: matterId,
                            participants: participants.map(function(participant) {
                                //fullName: '', email: '', isGift: false
                                var fullName = participant.fullName, email = participant.email, isGift = participant.isGift;
                                if (!fullName && !email && !isGift && participants[0]) {
                                    fullName = participants[0].fullName;
                                    email = participants[0].email;
                                    isGift = participants[0].isGift;
                                }
                                return {
                                    name: fullName,
                                    email: email,
                                    gift: isGift
                                };
                            }),
                            selectedTicketId: currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.id,
                            discountCode: appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.codeName,
                            goodUrl: location.origin,
                            cancelUrl: location.origin,
                            errorUrl: location.origin,
                            amount: totalPrice,
                            // notificationGoodMail,
                            // notificationErrorMail,
                            // notificationFailMail,
                            currency: (currencySymbol === null || currencySymbol === void 0 ? void 0 : currencySymbol.code) || "USD"
                        };
                        _ctx.next = 10;
                        return TreedisPublicDAO/* default.createTicketOrder */.Z.createTicketOrder(body);
                    case 10:
                        data = _ctx.sent.data;
                        order = data.order;
                        orderId.current = order === null || order === void 0 ? void 0 : order.id;
                        if (!(ticketingGeneral.paymentType === Order/* TicketPaymentType.Pelecard */.fx.Pelecard || Number(totalPrice) === 0)) {
                            _ctx.next = 18;
                            break;
                        }
                        _ctx.next = 16;
                        return TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType || Order/* TicketPaymentType.NoPayment */.fx.NoPayment, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, body), {
                            orderId: order.id
                        }));
                    case 16:
                        ticketPayRes = _ctx.sent;
                        if (ticketPayRes && ticketPayRes.message.includes("Success")) {
                            if (ticketPayRes.ticketsWithoutCost) {
                                console.log("ticketPayRes", ticketPayRes);
                                setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                                    gameId: gameId
                                }));
                                handlePaymentSuccess();
                            } else {
                                setOrderLink(ticketPayRes.url);
                                setOrderStage(Order/* OrderStageEnum.payment */.t9.payment);
                            }
                        }
                    case 18:
                        setTicketOrderSent(false);
                        return _ctx.abrupt("return", {
                            ticketOrderId: order.id,
                            name: participants[0].fullName,
                            email: participants[0].email
                        });
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](0);
                        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                            isOpen: true,
                            message: _ctx.t0.message,
                            mode: InfoModal/* EInfoModal.error */.Y.error
                        }));
                    case 25:
                        _ctx.prev = 25;
                        setTicketOrderSent(false);
                        return _ctx.finish(25);
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    22,
                    25,
                    28
                ]
            ]);
        }));
        return function handleProceedPayment() {
            return _ref.apply(this, arguments);
        };
    }();
    var cancelOrder = function() {
        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: true,
            message: "Error paypal payment",
            mode: InfoModal/* EInfoModal.error */.Y.error
        }));
    };
    var paypalCreateOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data, actions) {
            var ticketOrderId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleProceedPayment();
                    case 2:
                        ticketOrderId = _ctx.sent.ticketOrderId;
                        console.log("ticketOrderId", ticketOrderId);
                        if (ticketOrderId) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("No order ID");
                    case 6:
                        orderId.current = ticketOrderId;
                        return _ctx.abrupt("return", actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        value: totalPrice,
                                        currency_code: currencySymbol.code
                                    }
                                }, 
                            ]
                        }));
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function paypalCreateOrder(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var paypalApproveOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data, actions) {
            var ticketPayRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType, {
                            data: {
                                orderId: orderId.current,
                                paymentId: data.orderID
                            }
                        });
                    case 2:
                        ticketPayRes = _ctx.sent;
                        if (ticketPayRes) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                            isOpen: true,
                            message: "Error paypal payment - orderId: ".concat(data.orderID),
                            mode: InfoModal/* EInfoModal.error */.Y.error
                        })));
                    case 5:
                        console.log("ticketPayRes", ticketPayRes);
                        setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                            gameId: gameId
                        }));
                        handlePaymentSuccess();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function paypalApproveOrder(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var stripeCreateOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ticketOrderId, name, email;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return handleProceedPayment();
                    case 3:
                        ref = _ctx.sent;
                        ticketOrderId = ref.ticketOrderId;
                        name = ref.name;
                        email = ref.email;
                        if (ticketOrderId) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error();
                    case 9:
                        return _ctx.abrupt("return", {
                            id: ticketOrderId,
                            totalPrice: totalPrice,
                            currency: currencySymbol.code,
                            name: name,
                            email: email,
                            tourId: tourId
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", null);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function stripeCreateOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var approveOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ticketPayRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType, {
                            data: {
                                orderId: orderId.current
                            }
                        });
                    case 2:
                        ticketPayRes = _ctx.sent;
                        console.log("ticketPayRes", ticketPayRes);
                        if (ticketPayRes) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                            gameId: gameId
                        }));
                        handlePaymentSuccess();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function approveOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var durationLabels = [
        [
            [
                day
            ],
            [
                days
            ]
        ],
        [
            [
                hour
            ],
            [
                hours
            ]
        ],
        [
            [
                min
            ],
            [
                mins
            ]
        ], 
    ];
    var formatTicketTime = function(duration) {
        var durtionMinLeft = duration;
        var durationDays = parseInt(String(durtionMinLeft / (24 * 60)), 10);
        durtionMinLeft -= durationDays * 60 * 24;
        var durationHours = parseInt(String(durtionMinLeft / 60), 10);
        durtionMinLeft -= durationHours * 60;
        return [
            durationDays,
            durationHours,
            durtionMinLeft
        ];
    };
    var ref7 = currentTicket || {}, durationType = ref7.durationType, limitDevices = ref7.limitDevices, duration = ref7.duration, maxParticipants = ref7.maxParticipants, tourLanguage = ref7.tourLanguage, ticketPrice = ref7.ticketPrice;
    var pillsList = [];
    if (durationType) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/ticketing/clock.svg",
                    alt: "clock-icon"
                }),
                formatTicketTime(duration).map(function(durationPart, num) {
                    if (durationPart) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                durationPart,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: durationPart === 1 ? durationLabels[num][0] : durationLabels[num][1]
                                }),
                                "\xa0"
                            ]
                        }, num);
                    }
                    return null;
                }),
                " ",
                durationType === types/* DurationType.from_purchase */.q.from_purchase ? from_purchase : from_login
            ]
        }, "durationType"));
    }
    if (limitDevices) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/ticketing/desktopMobile.svg",
                    alt: "desktop-mobile-icon"
                }),
                " ",
                limitDevices,
                " ",
                devices
            ]
        }, "limitDevices"));
    }
    if (maxParticipants) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-user-friends"
                }),
                max_participants,
                " ",
                maxParticipants
            ]
        }, "maxParticipants"));
    }
    if (tourLanguage) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fal fa-globe"
                }),
                tour_language,
                " ",
                tourLanguage
            ]
        }, "tourLanguage"));
    }
    if (ticketPrice) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fal fa-tag"
                }),
                ticketPrice,
                currencySymbol.symbol
            ]
        }, "ticketPrice"));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        className: "bl-ticket-order",
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-ticket-order-title",
                children: plane_name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-subTitle",
                children: [
                    available_for,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-ticket-order-pills",
                children: pillsList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-private-note-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-pnote-header",
                        children: private_note
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-pnote-content",
                        dangerouslySetInnerHTML: {
                            __html: currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.description
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-price",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-price-title",
                        children: [
                            participants.length,
                            " ",
                            ticket,
                            " X ",
                            currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.ticketPrice,
                            " ",
                            currencySymbol.code
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "bl-ticket-order-price-line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-price-cost",
                        children: [
                            participants.length * (currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.ticketPrice) || 0,
                            currencySymbol.symbol
                        ]
                    })
                ]
            }),
            currentTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DiscountField, {
                tourId: tourId,
                ticketId: ticketId,
                ticketingType: ticketingType,
                currencySign: currencySymbol.symbol,
                onDiscountApply: setAppliedDiscount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "bl-ticket-order-after-disc-line"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-gtotal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-gtotal-title",
                        children: grand_total
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-gtotal-price",
                        children: [
                            totalPrice,
                            currencySymbol.symbol
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-checkboxes",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                checked: checkbox1,
                                onChange: function() {
                                    return setCheckbox1(!checkbox1);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: ticketingGeneral.termsAndConditionsUrl,
                                target: "_blank",
                                children: legal_checkbox_1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                checked: checkbox2,
                                onChange: function() {
                                    return setCheckbox2(!checkbox2);
                                }
                            }),
                            legal_checkbox_2
                        ]
                    })
                ]
            }),
            ticketingGeneral && currentTicket && (ticketingGeneral.paymentType === Order/* TicketPaymentType.Pelecard */.fx.Pelecard || !ticketingGeneral.paid || totalPrice === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                ref: orderBtn,
                disabled: ticketOrderSent,
                className: "bl-ticket-order-pay-btn",
                onClick: handleProceedPayment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas icon"
                    }),
                    proceed_to_payment
                ]
            }),
            !_validateUsers(true) && ticketingGeneral && currentTicket && ticketingGeneral.paymentType === Order/* TicketPaymentType.Stripe */.fx.Stripe && totalPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StripePaymentButton, {
                translation: {
                    check_out: check_out
                },
                createOrder: stripeCreateOrder,
                settings: ticketingGeneral,
                approveOrder: approveOrder
            }),
            !_validateUsers(true) && (ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.apiUsername) && currencySymbol.code && currentTicket && ticketingGeneral.paymentType === Order/* TicketPaymentType.Paypal */.fx.Paypal && totalPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ch-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* PayPalButton */.q, {
                    shippingPreference: "NO_SHIPPING",
                    currency: currencySymbol.code,
                    options: {
                        clientId: ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.apiUsername,
                        currency: currencySymbol.code
                    },
                    style: {
                        color: "silver"
                    },
                    createOrder: paypalCreateOrder,
                    onApprove: paypalApproveOrder,
                    onError: cancelOrder
                })
            })
        ]
    });
};
/* harmony default export */ var components_OrderDetailsBlock = (OrderDetailsBlock);


/***/ }),

/***/ 30510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94556);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 38px;\n\n  .bl-steps-wrap {\n    width: 202px;\n    display: flex;\n    justify-content: space-between;\n\n    .step {\n      color: white;\n      width: 48px;\n      height: 48px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #bbbbbb;\n      font-weight: 400;\n      font-size: 32px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      border-radius: 50%;\n      z-index: 2;\n\n      &.active {\n        background-color: #4b4b4b;\n      }\n\n      &.done {\n        background-color: #ea475c;\n      }\n    }\n  }\n\n  hr {\n    position: absolute;\n    top: 10px;\n    width: 172px;\n    border: 1px solid #8e8e8e;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "StepsBlock__MainWrap",
    componentId: "sc-78f40250-0"
})(_templateObject());
var StepsBlock = function(props) {
    var count = props.count, active = props.active, _done = props.done, done = _done === void 0 ? [] : _done;
    var steps = [];
    for(var i = 0; i < count; i++)steps.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("step", active === i + 1 && "active", done.includes(i + 1) && "done"),
        children: done.includes(i + 1) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
            className: "fas fa-check"
        }) : i + 1
    }, i));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        className: "bl-steps-widget",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-steps-wrap",
                children: steps
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepsBlock);


/***/ }),

/***/ 47238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16592);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98592);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94556);
/* harmony import */ var _components_ticketingNew_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84345);
/* harmony import */ var _components_ticketingNew_static__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70712);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12781);
/* harmony import */ var _utils_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14045);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_ticketingNew_components_MoreInfoBtn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72225);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 15px;\n  min-height: 134px;\n\n  .bl-tm-first {\n    background: #ffffff;\n    border-radius: 0 10px 10px 0;\n    width: 108px;\n    min-width: 108px;\n    padding: 5px;\n    text-align: center;\n    ",
        ";\n\n    .bl-tm-first-title {\n      margin-top: 6px;\n      margin-bottom: 9px;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 18px;\n    }\n\n    .bl-tm-first-price {\n      font-weight: 500;\n      font-size: 30px;\n      line-height: 45px;\n      margin-bottom: 10px;\n    }\n\n    .bl-tm-first-start-btn {\n      background: #ea475c;\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);\n      border-radius: 6px;\n      color: white;\n      width: 89px;\n      height: 28px;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 18px;\n\n      i {\n        margin-left: 7px;\n      }\n\n      &:active {\n        opacity: 0.9;\n      }\n    }\n\n    .tim-radio-pick-wrap {\n      display: flex;\n      height: 23px;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      color: #a5a5a5;\n      font-weight: 600;\n      font-size: 15px;\n\n      &.picked {\n        color: #ea475c;\n      }\n\n      input {\n        width: 17px;\n        height: 17px;\n        margin-left: 5px;\n      }\n    }\n  }\n\n  .bl-tm-second {\n    overflow: hidden;\n    width: 100%;\n    margin-left: 1px;\n    padding: 5px;\n    background: #ffffff;\n    border-radius: 10px 0 0 10px;\n    position: relative;\n    ",
        ";\n\n    .bl-tm-second-desc {\n      min-height: 36px;\n      padding: 8px 10px 0 10px;\n      font-weight: 300;\n      font-size: 12px;\n      line-height: 18px;\n      max-height: 65px;\n\n      text-align: left;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .bl-tm-second-info-title {\n      font-weight: 300;\n      font-size: 12px;\n      line-height: 18px;\n      text-decoration-line: underline;\n      color: #969595;\n      margin-left: 10px;\n      margin-top: 7px;\n    }\n\n    .bl-tm-second-info-wrap {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: left;\n      margin-top: 7px;\n      padding: 0 2px;\n\n      .bl-tm-second-info-item {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #333333;\n        display: flex;\n        align-items: center;\n\n        img {\n          width: 18px;\n          height: 18px;\n          margin-right: 3px;\n        }\n      }\n\n      hr {\n        margin: 0 10px;\n        height: 13px;\n        border: none;\n        border-left: 1px solid black;\n\n        &:last-child {\n          display: none;\n        }\n      }\n    }\n\n    .bl-ticket-ending {\n      position: absolute;\n      height: 134px;\n      right: 0;\n      top: 0;\n      ",
        ";\n\n      .bl-ticket-end-rect {\n        width: 12px;\n        height: 16px;\n        background: #e5e5e5;\n        border-radius: 12px 0 0 12px;\n\n        &.bl-rect-1 {\n          margin-top: 27px;\n        }\n\n        &.bl-rect-2 {\n          margin-top: 15px;\n        }\n\n        &.bl-rect-3 {\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TicketItemMobile__MainWrap",
    componentId: "sc-769d7f18-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 10px 0 0 10px;margin-left: 3px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 0 10px 10px 0;padding-left: 13px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "left: 0;right: initial;transform: scale(-1, 1);" : "");
});
var TicketItemMobile = function(props) {
    var ticket = props.ticket, currencyId = props.currencyId, match = props.match, onPick = props.onPick, pickedId = props.pickedId;
    var durationType = ticket.durationType, limitDevices = ticket.limitDevices, duration = ticket.duration, maxParticipants = ticket.maxParticipants, tourLanguage = ticket.tourLanguage, ticketInfoUlr = ticket.ticketInfoUlr;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_5__/* .translationDataState */ .Jv), _available_for = ref.available_for, available_for = _available_for === void 0 ? "Available for" : _available_for, _start = ref.start, start = _start === void 0 ? "start" : _start, _devices = ref.devices, devices = _devices === void 0 ? "devices" : _devices, _day = ref.day, day = _day === void 0 ? "day" : _day, _days = ref.days, days = _days === void 0 ? "days" : _days, _hour = ref.hour, hour = _hour === void 0 ? "hour" : _hour, _hours = ref.hours, hours = _hours === void 0 ? "hours" : _hours, _min = ref.min, min = _min === void 0 ? "min" : _min, _mins = ref.mins, mins = _mins === void 0 ? "mins" : _mins, _from_purchase = ref.from_purchase, from_purchase = _from_purchase === void 0 ? "from purchase" : _from_purchase, _from_login = ref.from_login, from_login = _from_login === void 0 ? "from login" : _from_login, _max_participants = ref.max_participants, max_participants = _max_participants === void 0 ? "Max. participants" : _max_participants, _tour_language = ref.tour_language, tour_language = _tour_language === void 0 ? "Tour language" : _tour_language;
    var rtl = (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_5__/* .tourConfigsState */ .Uq).rtl;
    var tourType = match.params.tourType;
    var durationLabels = [
        [
            [
                day
            ],
            [
                days
            ]
        ],
        [
            [
                hour
            ],
            [
                hours
            ]
        ],
        [
            [
                min
            ],
            [
                mins
            ]
        ], 
    ];
    var formatTicketTime = function(duration) {
        var durtionMinLeft = duration;
        var durationDays = parseInt(String(durtionMinLeft / (24 * 60)), 10);
        durtionMinLeft -= durationDays * 60 * 24;
        var durationHours = parseInt(String(durtionMinLeft / 60), 10);
        durtionMinLeft -= durationHours * 60;
        return [
            durationDays,
            durationHours,
            durtionMinLeft
        ];
    };
    var currencySymbol = _components_ticketingNew_static__WEBPACK_IMPORTED_MODULE_4__/* .initialCurrency.find */ .Z.find(function(cur) {
        return cur.id === currencyId;
    });
    var infoItems = [];
    if (durationType) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/ticketing/clock.svg",
                    alt: "clock-icon"
                }),
                formatTicketTime(duration).map(function(durationPart, num) {
                    if (durationPart) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                            children: [
                                durationPart,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    children: durationPart === 1 ? durationLabels[num][0] : durationLabels[num][1]
                                }),
                                "\xa0"
                            ]
                        }, num);
                    }
                    return null;
                }),
                " ",
                durationType === _components_ticketingNew_types__WEBPACK_IMPORTED_MODULE_3__/* .DurationType.from_purchase */ .q.from_purchase ? from_purchase : from_login
            ]
        }, "durationType_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "durationType_hr"));
    }
    if (limitDevices) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/ticketing/desktopMobile.svg",
                    alt: "desktop-mobile-icon"
                }),
                " ",
                limitDevices,
                " ",
                devices
            ]
        }, "limitDevices_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "limitDevices_hr"));
    }
    if (maxParticipants) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                    className: "fas fa-user-friends"
                }),
                max_participants,
                " ",
                maxParticipants
            ]
        }, "maxParticipants_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "maxParticipants_hr"));
    }
    if (tourLanguage) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                    className: "fal fa-globe"
                }),
                tour_language,
                " ",
                tourLanguage
            ]
        }, "tourLanguage_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "tourLanguage_hr"));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bl-tm-first",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-first-title",
                        children: ticket.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-tm-first-price",
                        children: [
                            ticket.ticketPrice,
                            currencySymbol.symbol
                        ]
                    }),
                    !onPick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .rU, {
                        to: "".concat(tourType, "/").concat(ticket.id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                            className: "bl-tm-first-start-btn",
                            children: [
                                (0,_utils_string__WEBPACK_IMPORTED_MODULE_6__/* .capitalize */ .kC)(start),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    className: "fas fa-chevron-right"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()("tim-radio-pick-wrap", ticket.id === pickedId && "picked"),
                        children: [
                            ticket.id === pickedId ? "Picked" : "Pick",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                type: "radio",
                                onChange: function() {
                                    return onPick(ticket.id);
                                },
                                checked: ticket.id === pickedId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bl-tm-second",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-second-desc",
                        dangerouslySetInnerHTML: {
                            __html: ticket.description
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-tm-second-info-title",
                        children: [
                            available_for,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-second-info-wrap",
                        children: infoItems
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-ticket-ending",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ticketingNew_components_MoreInfoBtn__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        ticketInfoUlr: ticketInfoUlr
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_router_dom__WEBPACK_IMPORTED_MODULE_11__/* .withRouter */ .EN)(TicketItemMobile));


/***/ }),

/***/ 70883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94556);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12781);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 133px;\n  background-color: #282828;\n  position: relative;\n\n  .bl-minimized-vector {\n    width: 0;\n    height: 0;\n    right: 0;\n    top: 0;\n    position: absolute;\n    border-bottom: 133px solid #ea475c;\n    border-left: 241px solid transparent;\n  }\n\n  .bl-minimized-title {\n    margin: 0;\n    height: 100%;\n    padding: 0 300px 0 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    //margin-top: 38px;\n    //margin-left: 80px;\n    font-weight: 400;\n    font-size: 40px;\n    line-height: 60px;\n    color: white;\n    position: absolute;\n    //max-height: calc(100% - 38px);\n    overflow: hidden;\n\n    @media screen and (max-width: 760px) {\n      width: 100%;\n      text-align: center;\n      margin-left: 0;\n    }\n  }\n\n  @media screen and (max-width: 760px) {\n    height: 77px;\n    .bl-minimized-title {\n      padding: inherit;\n      margin: 0;\n\n      text-align: left;\n      font-style: normal;\n      font-weight: 500;\n      font-size: 22px;\n      line-height: 33px;\n      //margin-top: 20px;\n      //padding-left: 24px;\n      //max-height: calc(100% - 20px);\n    }\n    .bl-minimized-vector {\n      border-right: 84px solid #ea475c;\n      border-bottom: 77px solid transparent;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TourImageDescriptionMinized__MainWrap",
    componentId: "sc-255bc9f8-0"
})(_templateObject());
var TourImageDescriptionMinized = function() {
    var ticketingGeneral = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .ticketingDataState */ .$W).ticketingGeneral;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-minimized-vector"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-minimized-title",
                dangerouslySetInnerHTML: {
                    __html: ticketingGeneral.title
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TourImageDescriptionMinized);


/***/ }),

/***/ 67020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t9": function() { return /* binding */ OrderStageEnum; },
  "fx": function() { return /* binding */ TicketPaymentType; },
  "ZP": function() { return /* binding */ pages_Order; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./components/ticketingNew/components/TourImageDescriptionMinized.tsx
var TourImageDescriptionMinized = __webpack_require__(70883);
// EXTERNAL MODULE: ./components/ticketingNew/components/StepsBlock.tsx
var StepsBlock = __webpack_require__(30510);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
// EXTERNAL MODULE: ./node_modules/react-switch/index.js
var react_switch = __webpack_require__(59936);
// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(14045);
;// CONCATENATED MODULE: ./components/ticketingNew/components/UserCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-item {\n    height: 141px;\n    display: flex;\n    margin-bottom: 11px;\n\n    .bl-ticket-desc {\n      width: 108px;\n      min-width: 108px;\n      background: #ffffff;\n      border-radius: 0 12px 12px 0;\n      margin-right: 3px;\n      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));\n      text-align: center;\n      position: relative;\n      ",
        ";\n\n      .bl-ticket-number-text {\n        margin-top: 17px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 21px;\n      }\n\n      .bl-ticket-number {\n        font-weight: 400;\n        font-size: 60px;\n        line-height: 90px;\n      }\n\n      .bl-ticket-triangle {\n        width: 0;\n        height: 0;\n        border-bottom: 29px solid #ea475c;\n        border-right: 49px solid transparent;\n        position: absolute;\n        bottom: 0;\n        ",
        ";\n      }\n    }\n\n    .bl-ticket-data {\n      padding-top: 29px;\n      padding-left: 20px;\n      padding-right: 54px;\n      width: 100%;\n      background: #ffffff;\n      border-radius: 12px 0 0 12px;\n      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));\n      ",
        ";\n\n      label {\n        display: flex;\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 22px;\n        margin-bottom: 19px;\n        justify-content: space-between;\n\n        span {\n          ",
        ";\n        }\n\n        .bl-text-input {\n          height: 23px;\n          width: 251px;\n          border: 1px solid #c4c4c4;\n          box-sizing: border-box;\n          border-radius: 4px;\n\n          &:active,\n          &:focus {\n            outline-color: #c4c4c4;\n          }\n        }\n      }\n\n      .bl-field-2 {\n        label {\n          margin-bottom: 15px;\n        }\n      }\n\n      .bl-field-3 {\n        label {\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 20px;\n          justify-content: space-between;\n          width: 117px;\n          float: right;\n        }\n\n        .bl-field-close {\n          float: left;\n          display: flex;\n          align-items: baseline;\n          cursor: pointer;\n          color: #ea475c;\n          //line-height: 13px;\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 15px;\n\n          .bl-close-circle {\n            width: 13px;\n            height: 13px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background-color: #ea475c;\n            margin: 6px;\n            color: white;\n            border-radius: 50%;\n\n            i {\n              font-weight: normal;\n              font-size: 10px;\n            }\n          }\n        }\n      }\n\n      .bl-ticket-ending {\n        position: absolute;\n        height: 141px;\n        right: 0;\n        top: 0;\n        ",
        ";\n\n        .bl-ticket-end-rect {\n          width: 18px;\n          height: 21px;\n          background: #e5e5e5;\n          border-radius: 12px 0 0 12px;\n\n          &.bl-rect-1 {\n            margin-top: 20px;\n          }\n\n          &.bl-rect-2 {\n            margin-top: 19px;\n          }\n\n          &.bl-rect-3 {\n            margin-top: 19px;\n          }\n        }\n      }\n\n      @media screen and (max-width: 760px) {\n        ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var getNumAsText = function(num) {
    var getLiteralLess13 = function(num) {
        switch(num){
            case 1:
                return "one";
            case 2:
                return "two";
            case 3:
                return "three";
            case 4:
                return "four";
            case 5:
                return "five";
            case 6:
                return "six";
            case 7:
                return "seven";
            case 8:
                return "eight";
            case 9:
                return "nine";
            case 10:
                return "ten";
            case 11:
                return "eleven";
            case 12:
                return "twelve";
            //1x teen
            case 13:
                return "thirteen";
        }
    };
    if (num < 13) return getLiteralLess13(num);
    if (num === 13) return "thirteen";
    if (num === 15) return "fifteen";
    if (num > 13 && num < 20) return getLiteralLess13(num - 10) + "teen";
    if (num === 20) return "twenty";
    if (num > 20 && num < 30) return "twenty" + getLiteralLess13(num - 20);
    if (num === 30) return "thirty";
    if (num > 30 && num < 40) return "thirty" + getLiteralLess13(num - 30);
    if (num === 40) return "fourty";
    if (num > 40 && num < 50) return "fourty" + getLiteralLess13(num - 40);
    return num;
};
var TicketItemMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UserCard__TicketItemMainWrap",
    componentId: "sc-953b2f2e-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin-left: 3px; margin-right: 0; border-radius: 12px 0 0 12px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "transform: scale(-1, 1); right: -1px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 0 12px 12px 0; padding: 29px 20px 0 54px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right:12px;left:initial!important;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;left: -2px;transform: scale(-1,1);" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding-left:20px!important;padding-right: 10px!important;" : "");
});
var UserCard = function(props) {
    var ticket = props.ticket, ticketNum = props.ticketNum, setTicketData = props.setTicketData, removeTicket = props.removeTicket;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _user = ref.user, user = _user === void 0 ? "User" : _user, _full_name = ref.full_name, full_name = _full_name === void 0 ? "Full name" : _full_name, _email = ref.email, email = _email === void 0 ? "Email" : _email, _close = ref.close, close = _close === void 0 ? "Close" : _close, _send_as_gift = ref.send_as_gift, send_as_gift = _send_as_gift === void 0 ? "Send as gift" : _send_as_gift;
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TicketItemMainWrap, {
        className: "bl-ticket-item",
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-desc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-number-text",
                        children: [
                            user,
                            " ",
                            getNumAsText(ticketNum + 1)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-number",
                        children: ticketNum + 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-triangle"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-data",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-field-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "*",
                                        (0,string/* capitalize */.kC)(full_name)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "bl-text-input",
                                    onChange: function(ev) {
                                        return setTicketData({
                                            id: ticket.id,
                                            target: "fullName",
                                            value: ev.target.value
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-field-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "*",
                                        (0,string/* capitalize */.kC)(email)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "bl-text-input",
                                    onChange: function(ev) {
                                        return setTicketData({
                                            id: ticket.id,
                                            target: "email",
                                            value: ev.target.value
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-field-3",
                        children: [
                            ticketNum > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-field-close",
                                onClick: function() {
                                    return removeTicket(ticket.id);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-close-circle",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-times"
                                        })
                                    }),
                                    (0,string/* capitalize */.kC)(close)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    send_as_gift,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_switch["default"], {
                                        onColor: "#ea475c",
                                        checked: ticket.isGift,
                                        onChange: function(newIsGift) {
                                            return setTicketData({
                                                id: ticket.id,
                                                target: "isGift",
                                                value: newIsGift
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-ending",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-3"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_UserCard = (UserCard);

// EXTERNAL MODULE: ./components/ticketingNew/components/BackButton.tsx
var BackButton = __webpack_require__(7710);
// EXTERNAL MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx + 2 modules
var OrderDetailsBlock = __webpack_require__(61749);
;// CONCATENATED MODULE: ./components/ticketingNew/pages/Order/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .bl-signUp-text {\n    text-align: center;\n    font-weight: 500;\n    font-size: 30px;\n    line-height: 45px;\n    margin-top: 20px;\n    margin-bottom: 88px;\n  }\n\n  .bl-ticket-main-wrap {\n    margin-left: 163px;\n    margin-right: 220px;\n    display: flex;\n\n    .bl-tickets-wrap {\n      margin-right: ",
        ";\n      margin-left: ",
        ";\n      width: calc(50% - 16px);\n      display: inline-block;\n\n      .bl-add-ticket-wrap {\n        margin-top: 15px;\n        display: flex;\n        align-items: baseline;\n        cursor: pointer;\n\n        &:active {\n          opacity: 0.8;\n        }\n\n        .bl-add-plus {\n          width: 21px;\n          height: 21px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background: #ea475c;\n          border-radius: 2px;\n          color: white;\n        }\n\n        .bl-add-text {\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 18px;\n          margin-left: 10px;\n          ",
        ";\n        }\n      }\n    }\n  }\n\n  .bl-payment-wrap {\n    height: 466px;\n    width: 582px;\n    margin: auto;\n    cursor: pointer;\n  }\n\n  .ch-btn {\n    text-align: center;\n    margin-top: 37px;\n  }\n\n  @media screen and (max-width: 760px) {\n    .bl-steps-widget {\n      margin-top: 0;\n    }\n\n    .bl-signUp-text {\n      margin-bottom: 0;\n    }\n\n    .bl-ticket-main-wrap {\n      display: flex;\n      flex-direction: column;\n      margin: 15px 22px;\n\n      .bl-ticket-order {\n        width: 100%;\n        padding: 15px;\n\n        .bl-ticket-order-pills {\n          margin-bottom: 14px;\n\n          .bl-ticket-order-pill {\n            margin-bottom: 8px;\n          }\n        }\n\n        .bl-ticket-order-pay-btn {\n          padding: 12px;\n          width: 100%;\n        }\n      }\n\n      .bl-tickets-wrap {\n        width: 100%;\n        margin-bottom: 20px;\n        margin-right: 0;\n\n        .bl-ticket-item {\n          position: relative;\n          display: flex;\n          width: 100%;\n\n          .bl-ticket-desc {\n            width: 83px;\n            min-width: 83px;\n          }\n\n          .bl-ticket-data {\n            padding: 9px 17px 18px 14px;\n            overflow: hidden;\n            //width: auto;\n            width: 100%;\n            padding-right: 27px;\n\n            .bl-field-1 {\n              margin-top: 12px;\n            }\n\n            .bl-field-2 {\n              margin-top: 21px;\n            }\n\n            .bl-field-1,\n            .bl-field-2 {\n              label {\n                position: relative;\n              }\n\n              span {\n                line-height: 1;\n                position: absolute;\n                background: white;\n                top: -12px;\n                left: 12px;\n              }\n\n              input {\n                height: 30px;\n                width: 100%;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .bl-payment-wrap {\n      max-width: 100%;\n\n      img {\n        max-width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n\n  @media screen and (min-width: 1057px) and (max-width: 1440px) {\n    .bl-ticket-main-wrap {\n      width: 1057px;\n      margin: auto;\n    }\n  }\n  @media screen and (min-width: 760px) and (max-width: 1057px) {\n    .bl-ticket-main-wrap {\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      width: 519px;\n      margin: auto;\n\n      .bl-tickets-wrap {\n        width: 100%;\n      }\n\n      .bl-ticket-order {\n        width: 100%;\n      }\n    }\n  }\n  @media screen and (min-width: 1440px) {\n    .bl-ticket-main-wrap {\n      max-width: 1080px;\n      margin: auto;\n    }\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var OrderMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__OrderMainWrap",
    componentId: "sc-88f0c1f1-0"
})(styled_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "initial" : "16px");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "16px" : "initial");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 10px;" : "");
});

;// CONCATENATED MODULE: ./components/ticketingNew/pages/Order/index.tsx














var getInitialTicketData = function() {
    return {
        id: Date.now(),
        fullName: "",
        email: "",
        isGift: false
    };
};
var OrderStageEnum;
(function(OrderStageEnum) {
    OrderStageEnum[OrderStageEnum["order"] = 2] = "order";
    OrderStageEnum[OrderStageEnum["payment"] = 3] = "payment";
    OrderStageEnum[OrderStageEnum["tourOrderOnlySuccess"] = 4] = "tourOrderOnlySuccess";
})(OrderStageEnum || (OrderStageEnum = {}));
var TicketPaymentType;
(function(TicketPaymentType) {
    TicketPaymentType["NoPayment"] = "noPayment";
    TicketPaymentType["Paypal"] = "paypal";
    TicketPaymentType["Stripe"] = "stripe";
    TicketPaymentType["Pelecard"] = "pelecard";
})(TicketPaymentType || (TicketPaymentType = {}));
var Order = function(props) {
    var match = props.match, matterId = props.matterId, tourId = props.tourId, gameId = props.gameId;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _add_a_ticket = ref.add_a_ticket, add_a_ticket = _add_a_ticket === void 0 ? "Add a ticket" : _add_a_ticket, _sign_up_process = ref.sign_up_process, sign_up_process = _sign_up_process === void 0 ? "Sign up process" : _sign_up_process, _payment = ref.payment, payment = _payment === void 0 ? "Payment" : _payment;
    var history = (0,react_router/* useHistory */.k6)();
    var ref1 = (0,react.useState)(OrderStageEnum.order), orderStage = ref1[0], setOrderStage = ref1[1];
    var ref2 = (0,react.useState)([
        getInitialTicketData()
    ]), participants = ref2[0], setParticipants = ref2[1];
    var ref3 = (0,react.useState)(""), orderLink = ref3[0], setOrderLink = ref3[1];
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    var handleAddTicket = function() {
        return setParticipants((0,_to_consumable_array/* default */.Z)(participants).concat([
            getInitialTicketData()
        ]));
    };
    var handleSetTicketData = function(props) {
        setParticipants(participants.map(function(ticket) {
            if (ticket.id === props.id) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticket), (0,_define_property/* default */.Z)({}, props.target, props.value));
            return ticket;
        }));
    };
    var handleRemoveTicket = function(id) {
        setParticipants(participants.filter(function(ticket) {
            return ticket.id !== id;
        }));
    };
    var handlePaymentSuccess = function() {
        var ref, ref1;
        if (match === null || match === void 0 ? void 0 : (ref = match.params) === null || ref === void 0 ? void 0 : ref.ticketId) history.push("".concat(match === null || match === void 0 ? void 0 : (ref1 = match.params) === null || ref1 === void 0 ? void 0 : ref1.ticketId, "/success"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderMainWrap, {
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TourImageDescriptionMinized/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                backFunction: orderStage === OrderStageEnum.order ? null : function() {
                    setOrderStage(OrderStageEnum.order);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsBlock/* default */.Z, {
                count: 3,
                active: orderStage,
                done: orderStage === OrderStageEnum.order ? [
                    1
                ] : [
                    1,
                    2
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-signUp-text",
                children: orderStage === OrderStageEnum.order ? sign_up_process : payment
            }),
            orderStage === OrderStageEnum.order ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-main-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-tickets-wrap",
                        children: [
                            participants.map(function(ticket, ticketNum) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserCard, {
                                    ticket: ticket,
                                    ticketNum: ticketNum,
                                    setTicketData: handleSetTicketData,
                                    removeTicket: handleRemoveTicket
                                }, ticket.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-add-ticket-wrap",
                                onClick: handleAddTicket,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-add-plus",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-plus"
                                        })
                                    }),
                                    participants.length < 50 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-add-text",
                                        children: add_a_ticket
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailsBlock/* default */.Z, {
                        matterId: matterId,
                        match: match,
                        handlePaymentSuccess: handlePaymentSuccess,
                        participants: participants,
                        setOrderStage: setOrderStage,
                        tourId: tourId,
                        gameId: gameId,
                        setOrderLink: setOrderLink
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-payment-wrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: orderLink
                })
            })
        ]
    });
};
/* harmony default export */ var pages_Order = ((0,react_router/* withRouter */.EN)(Order));


/***/ }),

/***/ 99931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pages_OrderSuccess; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./components/ticketingNew/components/TourImageDescriptionMinized.tsx
var TourImageDescriptionMinized = __webpack_require__(70883);
// EXTERNAL MODULE: ./components/ticketingNew/components/StepsBlock.tsx
var StepsBlock = __webpack_require__(30510);
;// CONCATENATED MODULE: ./components/ticketingNew/components/TicketingButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  border: ",
        ";\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);\n  border-radius: 12px;\n  padding: 16px 30px;\n  font-weight: 600;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: initial;\n\n  &:active {\n    ",
        "\n  }\n\n  &:focus {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ETickBtnType;
(function(ETickBtnType) {
    ETickBtnType[ETickBtnType["white"] = 0] = "white";
    ETickBtnType[ETickBtnType["red"] = 1] = "red";
})(ETickBtnType || (ETickBtnType = {}));
var MainWrap = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "TicketingButton__MainWrap",
    componentId: "sc-cf052c43-0"
})(_templateObject(), function(p) {
    return p.type == ETickBtnType.red ? "white" : "#EA475C";
}, function(p) {
    return p.type == ETickBtnType.red ? "#EA475C" : "white";
}, function(p) {
    return p.type == ETickBtnType.red ? "none" : "2px solid #EA475C";
}, function(p) {
    return p.type == ETickBtnType.red ? "opacity:0.8;" : "background-color:rgba(234,71,92,0.2);";
}, function(p) {
    return p.type == ETickBtnType.red ? "" : "border:2px solid #EA475C;";
});
var TicketingButton = function(props) {
    var text = props.text, _type = props.type, type = _type === void 0 ? ETickBtnType.red : _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainWrap, {
        type: type,
        children: text
    });
};
/* harmony default export */ var components_TicketingButton = (TicketingButton);

// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
;// CONCATENATED MODULE: ./components/ticketingNew/pages/OrderSuccess.tsx

function OrderSuccess_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  .bl-success-block-wrap {\n    background: #ffffff;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);\n    border-radius: 4px;\n    width: 570px;\n    margin: auto;\n    margin-top: 48px;\n    padding: 71px 37px 38px 37px;\n    position: relative;\n    text-align: center;\n\n    .bl-success-block-triangle {\n      width: 0;\n      height: 0;\n      border-top: 108px solid #ea475c;\n      border-right: 171px solid transparent;\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n\n    .bl-success-block-ok-sign {\n      width: 71px;\n      height: 71px;\n      background-color: #ea475c;\n      border-radius: 50%;\n      margin: auto;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      font-size: 45px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      margin-bottom: 20px;\n    }\n\n    .bl-success-block-title {\n      font-weight: 500;\n      font-size: 30px;\n      line-height: 45px;\n      margin-bottom: 20px;\n    }\n\n    .bl-success-block-text {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 130.3%;\n      margin-bottom: 38px;\n    }\n\n    .bl-success-btns {\n      justify-content: space-between;\n      display: flex;\n      margin: auto;\n      margin-bottom: 40px;\n      width: 426px;\n\n      a {\n        text-decoration: initial;\n      }\n\n      button {\n        min-width: 202px;\n      }\n    }\n\n    .bl-success-block-safety {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 20px;\n      display: flex;\n      align-items: baseline;\n\n      .bl-success-block-safety-icon {\n        margin: 0 10px;\n        border: 1px solid black;\n        border-radius: 50%;\n        width: 28px;\n        height: 28px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  @media screen and (max-width: 760px) {\n    .bl-success-block-wrap {\n      display: flex;\n      flex-direction: column;\n      max-width: calc(100% - 30px);\n      margin-left: 15px;\n      margin-right: 15px;\n      padding-top: 36px;\n      padding-bottom: 28px;\n\n      .bl-success-block-triangle {\n        border-top: 73px solid #ea475c;\n        border-right: 116px solid transparent;\n      }\n\n      .bl-success-block-ok-sign {\n        order: 1;\n      }\n\n      .bl-success-block-title {\n        order: 0;\n      }\n\n      .bl-success-block-text {\n        order: 3;\n      }\n\n      .bl-success-block-safety {\n        order: 4;\n      }\n\n      .bl-success-block-safety-icon {\n        min-width: 28px;\n      }\n\n      .bl-success-btns {\n        order: 4;\n        flex-wrap: wrap;\n        justify-content: center;\n\n        button {\n          width: 100%;\n        }\n\n        button:first-child {\n          margin-bottom: 15px;\n        }\n      }\n    }\n  }\n"
    ]);
    OrderSuccess_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var OrderSuccess_MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderSuccess__MainWrap",
    componentId: "sc-39b9e4a9-0"
})(OrderSuccess_templateObject(), function(p) {
    return p.minimized ? "color:initial;" : "";
});
var OrderSuccess = function(props) {
    var location = props.location, _minimized = props.minimized, minimized = _minimized === void 0 ? false : _minimized, _onLinkClick = props.onLinkClick, onLinkClick = _onLinkClick === void 0 ? function() {} : _onLinkClick;
    var ticketsRes = (0,store/* useRecoilValue */.sJ)(store/* orderedTicketsState */.jF);
    var history = (0,react_router/* useHistory */.k6)();
    console.log("ticketsRes success page", ticketsRes);
    var firstTicket;
    var firstTicketCode;
    if (ticketsRes) {
        var ref;
        firstTicket = ticketsRes === null || ticketsRes === void 0 ? void 0 : (ref = ticketsRes.tickets) === null || ref === void 0 ? void 0 : ref.find(function(t) {
            return t.code;
        });
        firstTicketCode = firstTicket === null || firstTicket === void 0 ? void 0 : firstTicket.code;
    }
    var bookPage = location.pathname.replace(/book.+|book/g, "") + "book";
    if (!firstTicket) {
        react_toastify_esm/* toast.error */.Am.error("No ticket found, redirecting to home page");
        history.push(bookPage);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "redirect"
        });
    }
    var loginPage = location.pathname.replace(/book.+|book/g, "") + "login?ticket=".concat(firstTicketCode);
    if (firstTicket.type === "gameTour" && ticketsRes.gameId) loginPage.replace("/tour/", "/experience/".concat(ticketsRes.gameId, "/"));
    var ref1 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _payment_confirmed = ref1.payment_confirmed, payment_confirmed = _payment_confirmed === void 0 ? "Payment cofirmed" : _payment_confirmed, _full_transaction_details = ref1.full_transaction_details, full_transaction_details = _full_transaction_details === void 0 ? "The full transaction details will be sending to your Email" : _full_transaction_details, _protect_message = ref1.protect_message, protect_message = _protect_message === void 0 ? "We protect your payment information using encryption to provide bank-level security." : _protect_message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderSuccess_MainWrap, {
        minimized: minimized,
        children: [
            !minimized && /*#__PURE__*/ (0,jsx_runtime.jsx)(TourImageDescriptionMinized/* default */.Z, {}),
            !minimized && /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsBlock/* default */.Z, {
                count: 3,
                active: 3,
                done: [
                    1,
                    2
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-success-block-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-triangle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-ok-sign",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "far fa-check"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-title",
                        children: payment_confirmed
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-text",
                        children: full_transaction_details
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-success-btns",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: bookPage,
                                onClick: onLinkClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketingButton, {
                                    text: "Book More Tours",
                                    type: ETickBtnType.white
                                })
                            }),
                            firstTicketCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: loginPage,
                                onClick: onLinkClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketingButton, {
                                    text: "Start Tour Now"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-success-block-safety",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-success-block-safety-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-lock"
                                })
                            }),
                            protect_message
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_OrderSuccess = ((0,react_router/* withRouter */.EN)(OrderSuccess));


/***/ }),

/***/ 70712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getTicketingTypeFromOrderedTicket; },
/* harmony export */   "Z": function() { return /* binding */ initialCurrency; }
/* harmony export */ });
var initialCurrency = [
    {
        id: 1,
        name: "Euro",
        code: "EUR",
        symbol: "\u20AC"
    },
    {
        id: 3,
        name: "US Dollar",
        code: "USD",
        symbol: "$"
    },
    {
        id: 9,
        name: "Israeli New Sheqel",
        code: "ILS",
        symbol: "\u20AA"
    }, 
];
var getTicketingTypeFromOrderedTicket = function(ticketingOrderedTicket) {
    switch(ticketingOrderedTicket.ticketType){
        case "gameTour":
            return "ticketingGameTour";
        case "guidedTour":
            return "ticketingGuidedTour";
        // 'tourByYourself'
        default:
            return "ticketingToursByYourself";
    }
};


/***/ }),

/***/ 84345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ DurationType; }
/* harmony export */ });
var DurationType;
(function(DurationType) {
    DurationType["from_login"] = "from_login";
    DurationType["from_purchase"] = "from_purchase";
})(DurationType || (DurationType = {}));


/***/ }),

/***/ 31828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ Mode; },
/* harmony export */   "FX": function() { return /* binding */ ExternalProvider; },
/* harmony export */   "MP": function() { return /* binding */ ConditionLocationType; },
/* harmony export */   "XI": function() { return /* binding */ GameStatus; },
/* harmony export */   "_B": function() { return /* binding */ PAGE_PATH; }
/* harmony export */ });
/* unused harmony export TItemsFilter */
var TItemsFilter;
(function(TItemsFilter) {
    TItemsFilter[TItemsFilter["Tags"] = 0] = "Tags";
    TItemsFilter[TItemsFilter["Sweeps"] = 1] = "Sweeps";
})(TItemsFilter || (TItemsFilter = {}));
var Mode;
(function(Mode) {
    Mode[Mode["day"] = 3] = "day";
    Mode[Mode["week"] = 21] = "week";
    Mode[Mode["month"] = 90] = "month";
})(Mode || (Mode = {}));
var PAGE_PATH;
(function(PAGE_PATH) {
    PAGE_PATH["ALL"] = "all";
    PAGE_PATH["TOUR"] = "tour";
    PAGE_PATH["EXPERIENCE"] = "experience";
    PAGE_PATH["ECOMMERCE"] = "e-commerce-tour";
})(PAGE_PATH || (PAGE_PATH = {}));
var ConditionLocationType;
(function(ConditionLocationType) {
    ConditionLocationType["sweep"] = "sweep";
    ConditionLocationType["tourLink"] = "tourLink";
})(ConditionLocationType || (ConditionLocationType = {}));
var GameStatus;
(function(GameStatus) {
    GameStatus["NotStarted"] = "not_started";
    GameStatus["Started"] = "started";
    GameStatus["OutroClip"] = "outro_clip";
    GameStatus["SuccessfullyEnded"] = "successfully_ended";
    GameStatus["SuccessfullyEndedWithoutFinalScreen"] = "successfully_ended_without_final_screen";
    GameStatus["SuccessfullyEndedWithSimpleFinalScreen"] = "successfully_ended_with_simple_final_screen";
    GameStatus["TimeIsUpEnded"] = "timup_ended";
})(GameStatus || (GameStatus = {}));
var ExternalProvider;
(function(ExternalProvider) {
    ExternalProvider["SHOPIFY"] = "shopify";
    ExternalProvider["OPTICAL_CENTER"] = "opticalCenter";
    ExternalProvider["HAVELLS"] = "havells";
})(ExternalProvider || (ExternalProvider = {}));


/***/ }),

/***/ 12781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nJ": function() { return /* reexport */ activeItemState; },
  "b1": function() { return /* reexport */ bgImageState; },
  "DF": function() { return /* reexport */ bottomBarOpenState; },
  "b_": function() { return /* reexport */ captionsEnabledState; },
  "F3": function() { return /* reexport */ gamePointsState; },
  "WW": function() { return /* reexport */ gameSoundOnState; },
  "WN": function() { return /* reexport */ gameSoundVolumeState; },
  "uP": function() { return /* reexport */ infoModalDataState; },
  "wN": function() { return /* reexport */ lockInfoPopupStatusState; },
  "bG": function() { return /* reexport */ lockTimerState; },
  "jF": function() { return /* reexport */ orderedTicketsState; },
  "Sy": function() { return /* reexport */ redirectTicketsState; },
  "y9": function() { return /* reexport */ sidebarMinimizedState; },
  "eo": function() { return /* reexport */ sidebarOpenState; },
  "Ys": function() { return /* reexport */ ticketingCurrentLanguage; },
  "$W": function() { return /* reexport */ ticketingDataState; },
  "Uq": function() { return /* reexport */ tourConfigsState; },
  "Jv": function() { return /* reexport */ translationDataState; },
  "FV": function() { return /* reexport */ recoil/* useRecoilState */.FV; },
  "sJ": function() { return /* reexport */ recoil/* useRecoilValue */.sJ; },
  "Zl": function() { return /* reexport */ recoil/* useSetRecoilState */.Zl; },
  "Jn": function() { return /* reexport */ youtubeOnState; }
});

// UNUSED EXPORTS: DefaultValue, RecoilLoadable, RecoilRoot, atom, atomFamily, constSelector, errorSelector, isRecoilValue, noWait, readOnlySelector, retentionZone, selector, selectorFamily, snapshot_UNSTABLE, useGetRecoilValueInfo_UNSTABLE, useGotoRecoilSnapshot, useRecoilBridgeAcrossReactRoots_UNSTABLE, useRecoilCallback, useRecoilRefresher_UNSTABLE, useRecoilSnapshot, useRecoilStateLoadable, useRecoilTransactionObserver_UNSTABLE, useRecoilTransaction_UNSTABLE, useRecoilValueLoadable, useResetRecoilState, useRetain, useSetUnvalidatedAtomValues_UNSTABLE, useTransactionObservation_UNSTABLE, waitForAll, waitForAllSettled, waitForAny, waitForNone

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
;// CONCATENATED MODULE: ./store/atoms/basic.ts

var captionsEnabledState = (0,recoil/* atom */.cn)({
    key: "captionsEnabledState",
    default: true
});
var translationDataState = (0,recoil/* atom */.cn)({
    key: "translationDataState",
    default: null
});
var tourConfigsState = (0,recoil/* atom */.cn)({
    key: "tourConfigsState",
    default: {}
});

;// CONCATENATED MODULE: ./store/atoms/game/sound.ts

var gameSoundOnState = (0,recoil/* atom */.cn)({
    key: "gameSoundOnState",
    default: true
});
var gameSoundVolumeState = (0,recoil/* atom */.cn)({
    key: "gameSoundVolumeState",
    default: 0.5
});

;// CONCATENATED MODULE: ./store/atoms/game/basic.ts

var lockTimerState = (0,recoil/* atom */.cn)({
    key: "lockTimerState",
    default: {
        running: false,
        value: 0
    }
});
var lockInfoPopupStatusState = (0,recoil/* atom */.cn)({
    key: "lockInfoPopupStatusState",
    default: null
});
var gamePointsState = (0,recoil/* atom */.cn)({
    key: "gamePointsState",
    default: 0
});

;// CONCATENATED MODULE: ./store/atoms/game/index.ts



// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
;// CONCATENATED MODULE: ./store/atoms/ticketing.ts


var ticketingCurrentLanguage = (0,recoil/* atom */.cn)({
    key: "ticketingCurrentLanguage",
    default: {}
});
var infoModalDataState = (0,recoil/* atom */.cn)({
    key: "infoModalDataState",
    default: {
        mode: InfoModal/* EInfoModal.error */.Y.error,
        isOpen: false
    }
});
var redirectTicketsState = (0,recoil/* atom */.cn)({
    key: "redirectTicketsState",
    default: null
});
var orderedTicketsState = (0,recoil/* atom */.cn)({
    key: "orderedTicketsState",
    default: null
});
var ticketingDataState = (0,recoil/* atom */.cn)({
    key: "ticketingDataState",
    default: null
});
var bgImageState = (0,recoil/* atom */.cn)({
    key: "bgImageState",
    default: ""
});

// EXTERNAL MODULE: ./components-new/eCommerce/BottomBar/types.ts
var types = __webpack_require__(40803);
;// CONCATENATED MODULE: ./store/atoms/eCommerce.ts


var activeItemState = (0,recoil/* atom */.cn)({
    key: "activeItemState",
    default: types/* EBottomBarActiveItem.cart */.C.cart
});
var bottomBarOpenState = (0,recoil/* atom */.cn)({
    key: "bottomBarOpenState",
    default: false
});
var sidebarMinimizedState = (0,recoil/* atom */.cn)({
    key: "sidebarMinimizedState",
    default: true
});
var sidebarOpenState = (0,recoil/* atom */.cn)({
    key: "sidebarOpenState",
    default: false
});
var youtubeOnState = (0,recoil/* atom */.cn)({
    key: "youtubeOnState",
    default: false
});

;// CONCATENATED MODULE: ./store/atoms/index.ts





;// CONCATENATED MODULE: ./store/index.ts

 // export * from './selectors';


/***/ }),

/***/ 47835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./units/Icon/index.ts + 45 modules
var Icon = __webpack_require__(34915);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
;// CONCATENATED MODULE: ./units/Alert/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.75rem 1.25rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n\n  background-color: ",
        ";\n  color: ",
        ";\n  border-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var backgroundColor = {
    info: "#cce5ff",
    warning: "#fff3cd",
    error: "#f8d7da",
    success: "#d4edda"
};
var borderColor = {
    info: "#b8daff",
    warning: "#ffeeba",
    error: "#f5c6cb",
    success: "#c3e6cb"
};
var color = {
    info: "#004085",
    warning: "#856404",
    error: "#721c24",
    success: "#155724"
};
var AlertStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__AlertStyled",
    componentId: "sc-deb339e0-0"
})(_templateObject(), function(param) {
    var type = param.type;
    return backgroundColor[type];
}, function(param) {
    var type = param.type;
    return color[type];
}, function(param) {
    var type = param.type;
    return borderColor[type];
});

;// CONCATENATED MODULE: ./units/Alert/index.tsx






var getIcon = function(type) {
    switch(type){
        case "warning":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Warning */.Z.Warning, {});
            }
        case "error":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ExclamationMark */.Z.ExclamationMark, {});
            }
        case "success":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Check */.Z.Check, {});
            }
        case "info":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Info */.Z.Info, {});
            }
        default:
            return null;
    }
};
var Alert = function(_param) {
    var id = _param.id, type = _param.type, show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "type",
        "show",
        "children"
    ]);
    if (show) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            id: id,
            type: type
        }, restProps), {
            children: [
                getIcon(type),
                children
            ]
        }));
    }
    return null;
};
/* harmony default export */ var units_Alert = (Alert);


/***/ }),

/***/ 34915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Icon; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(81645);
;// CONCATENATED MODULE: ./units/Icon/ArrowDown.tsx




var Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Down"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M112 268l144 144 144-144M256 392V100"
            })
        ]
    }));
};
/* harmony default export */ var ArrowDown = (Icon);

;// CONCATENATED MODULE: ./units/Icon/ArrowUp.tsx




var ArrowUp_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Up"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M112 244l144-144 144 144M256 120v292"
            })
        ]
    }));
};
/* harmony default export */ var ArrowUp = (ArrowUp_Icon);

;// CONCATENATED MODULE: ./units/Icon/ArrowRight.tsx




var ArrowRight_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Right"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z"
            })
        ]
    }));
};
/* harmony default export */ var ArrowRight = (ArrowRight_Icon);

;// CONCATENATED MODULE: ./units/Icon/ChevronDown.tsx




var ChevronDown_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Down"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M112 184l144 144 144-144"
            })
        ]
    }));
};
/* harmony default export */ var ChevronDown = (ChevronDown_Icon);

;// CONCATENATED MODULE: ./units/Icon/ChevronLeft.tsx




var ChevronLeft_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "48",
            d: "M328 112L184 256l144 144"
        })
    }));
};
/* harmony default export */ var ChevronLeft = (ChevronLeft_Icon);

;// CONCATENATED MODULE: ./units/Icon/ChevronRight.tsx




var ChevronRight_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Forward"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M184 112l144 144-144 144"
            })
        ]
    }));
};
/* harmony default export */ var ChevronRight = (ChevronRight_Icon);

;// CONCATENATED MODULE: ./units/Icon/Close.tsx




var Close_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Close"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M368 368L144 144M368 144L144 368"
            })
        ]
    }));
};
/* harmony default export */ var Close = (Close_Icon);

;// CONCATENATED MODULE: ./units/Icon/ColorPalette.tsx




var ColorPalette_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Color Palette"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M430.11 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 11.99-36.6.1-47.7z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "144",
                cy: "208",
                r: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "152",
                cy: "311",
                r: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "224",
                cy: "144",
                r: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "256",
                cy: "367",
                r: "48"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "328",
                cy: "144",
                r: "32"
            })
        ]
    }));
};
/* harmony default export */ var ColorPalette = (ColorPalette_Icon);

;// CONCATENATED MODULE: ./units/Icon/Droplet.tsx




var Droplet_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0.652 0.759 9.825 13.46",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M5.565.759l-.557.557c-.18.18-4.356 4.405-4.356 7.99a4.927 4.927 0 0 0 4.913 4.913 4.927 4.927 0 0 0 4.912-4.912c0-3.57-4.176-7.811-4.356-7.991L5.565.759zM3.108 8.488a.81.81 0 0 1 .819.819c0 .9.737 1.637 1.638 1.637a.81.81 0 0 1 .818.819.81.81 0 0 1-.818.819A3.285 3.285 0 0 1 2.29 9.307a.81.81 0 0 1 .818-.82z"
        })
    }));
};
/* harmony default export */ var Droplet = (Droplet_Icon);

;// CONCATENATED MODULE: ./units/Icon/Edit.tsx




var Edit_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Edit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
            })
        ]
    }));
};
/* harmony default export */ var Edit = (Edit_Icon);

;// CONCATENATED MODULE: ./units/Icon/ExpandArrowsAlt.tsx




var ExpandArrowsAlt_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
        })
    }));
};
/* harmony default export */ var ExpandArrowsAlt = (ExpandArrowsAlt_Icon);

;// CONCATENATED MODULE: ./units/Icon/Filter.tsx




var Filter_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Forward"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
            })
        ]
    }));
};
/* harmony default export */ var Filter = (Filter_Icon);

;// CONCATENATED MODULE: ./units/Icon/Image.tsx




var Image_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "48",
                y: "80",
                width: "416",
                height: "352",
                rx: "48",
                ry: "48",
                fill: "none",
                stroke: "currentColor",
                strokeLinejoin: "round",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "336",
                cy: "176",
                r: "32",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M304 335.79l-90.66-90.49a32 32 0 00-43.87-1.3L48 352M224 432l123.34-123.34a32 32 0 0143.11-2L464 368",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32"
            })
        ]
    }));
};
/* harmony default export */ var Image = (Image_Icon);

;// CONCATENATED MODULE: ./units/Icon/Layout.tsx




var Layout_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Layout"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x1: "3",
                y1: "9",
                x2: "21",
                y2: "9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x1: "9",
                y1: "21",
                x2: "9",
                y2: "9"
            })
        ]
    }));
};
/* harmony default export */ var Layout = (Layout_Icon);

;// CONCATENATED MODULE: ./units/Icon/Loading.tsx




var Loading_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 1024 1024",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Loading"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
            })
        ]
    }));
};
/* harmony default export */ var Loading = (Loading_Icon);

;// CONCATENATED MODULE: ./units/Icon/Lock.tsx




var Lock_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 16 18",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Lock"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.84375 13.5C8.84375 13.9676 8.46758 14.3438 8 14.3438C7.53242 14.3438 7.15625 13.9676 7.15625 13.5V11.25C7.15625 10.7824 7.53242 10.4062 8 10.4062C8.46758 10.4062 8.84375 10.7824 8.84375 11.25V13.5ZM8 0C10.4855 0 12.5 2.0148 12.5 4.5V6.75H13.625C14.866 6.75 15.875 7.75898 15.875 9V15.75C15.875 16.991 14.866 18 13.625 18H2.375C1.13223 18 0.125 16.991 0.125 15.75V9C0.125 7.75898 1.13223 6.75 2.375 6.75H3.5V4.5C3.5 2.0148 5.51445 0 8 0ZM8 1.6875C6.44609 1.6875 5.1875 2.9468 5.1875 4.5V6.75H10.8125V4.5C10.8125 2.9468 9.55391 1.6875 8 1.6875ZM2.375 8.4375C2.06422 8.4375 1.8125 8.69063 1.8125 9V15.75C1.8125 16.0594 2.06422 16.3125 2.375 16.3125H13.625C13.9344 16.3125 14.1875 16.0594 14.1875 15.75V9C14.1875 8.69063 13.9344 8.4375 13.625 8.4375H2.375Z",
                fill: "currentColor"
            })
        ]
    }));
};
/* harmony default export */ var Lock = (Lock_Icon);

;// CONCATENATED MODULE: ./units/Icon/MetroShrink.tsx




var MetroShrink_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0.5 15 15",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M7.875 7.125h5.688l-2.188-2.188L14 2.312 12.687 1l-2.625 2.625-2.187-2.188v5.688zm0 1.75v5.687l2.187-2.187L12.687 15 14 13.687l-2.625-2.625 2.188-2.187H7.875zm-1.75 0H.437l2.188 2.187L0 13.687 1.313 15l2.624-2.625 2.188 2.187V8.875zm0-1.75V1.437L3.937 3.625 1.313 1 0 2.312l2.625 2.625L.437 7.125h5.688z"
        })
    }));
};
/* harmony default export */ var MetroShrink = (MetroShrink_Icon);

;// CONCATENATED MODULE: ./units/Icon/Redo.tsx




var Redo_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "14",
        viewBox: "0.081 0.138 15.684 13.723",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M7.923.138c2.165 0 4.126.878 5.545 2.298L15.765.138V6.02H9.884l2.198-2.198a5.882 5.882 0 1 0-8.049 8.57l-1.297 1.47A7.842 7.842 0 0 1 7.923.139z"
        })
    }));
};
/* harmony default export */ var Redo = (Redo_Icon);

;// CONCATENATED MODULE: ./units/Icon/Resize.tsx




var Resize_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "16",
        viewBox: "0.321 0.356 15.289 15.289",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M7.966.356l3.172 3.172-7.644 7.644L.32 8v7.644h7.645l-3.173-3.172 7.645-7.644L15.61 8V.356H7.966z"
        })
    }));
};
/* harmony default export */ var Resize = (Resize_Icon);

;// CONCATENATED MODULE: ./units/Icon/Ruler.tsx




var Ruler_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0.375 15 11.25",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M14.716 4.382l-1.842-3.137A.745.745 0 0 0 11.867.98l-1.598.905 1.382 2.354a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.251-.067L9.63 2.247l-1.277.725.646 1.097a.18.18 0 0 1-.068.248l-.319.18a.185.185 0 0 1-.252-.067l-.646-1.095-1.278.725L7.82 6.414a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.251-.067L5.799 4.421l-1.277.725.646 1.097a.18.18 0 0 1-.068.247l-.319.181a.185.185 0 0 1-.252-.067l-.646-1.1-1.278.725 1.382 2.354a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.252-.067L1.966 6.597.37 7.502a.72.72 0 0 0-.27.99l1.842 3.14a.745.745 0 0 0 1.007.266l11.5-6.526a.718.718 0 0 0 .268-.99z"
        })
    }));
};
/* harmony default export */ var Ruler = (Ruler_Icon);

;// CONCATENATED MODULE: ./units/Icon/Search.tsx




var Search_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "11",
                cy: "11",
                r: "8",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "21",
                y1: "21",
                x2: "16.65",
                y2: "16.65",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var Search = (Search_Icon);

;// CONCATENATED MODULE: ./units/Icon/SortAlphaDown.tsx




var SortAlphaDown_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Sort Alpha Down"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                d: "M187.298 395.314l-79.984 80.002c-6.248 6.247-16.383 6.245-22.627 0L4.705 395.314C-5.365 385.244 1.807 368 16.019 368H64V48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v320h47.984c14.241 0 21.363 17.264 11.314 27.314zm119.075-180.007A12 12 0 0 1 294.838 224h-35.717c-8.22 0-14.007-8.078-11.362-15.861l57.096-168A12 12 0 0 1 316.217 32h39.566c5.139 0 9.708 3.273 11.362 8.139l57.096 168C426.886 215.922 421.1 224 412.879 224h-35.735a12 12 0 0 1-11.515-8.622l-8.301-28.299h-42.863l-8.092 28.228zm22.857-78.697h13.367l-6.6-22.937-6.767 22.937zm12.575 287.323l67.451-95.698a12 12 0 0 0 2.192-6.913V300c0-6.627-5.373-12-12-12H274.522c-6.627 0-12 5.373-12 12v28.93c0 6.627 5.373 12 12 12h56.469c-.739.991-1.497 2.036-2.27 3.133l-67.203 95.205a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h129.355c6.627 0 12-5.373 12-12v-28.93c0-6.627-5.373-12-12-12h-61.146c.74-.993 1.5-2.039 2.274-3.137z"
            })
        ]
    }));
};
/* harmony default export */ var SortAlphaDown = (SortAlphaDown_Icon);

;// CONCATENATED MODULE: ./units/Icon/SortAlphaUp.tsx




var SortAlphaUp_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Sort Alpha Up"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                d: "M4.702 116.686l79.984-80.002c6.248-6.247 16.383-6.245 22.627 0l79.981 80.002c10.07 10.07 2.899 27.314-11.314 27.314H128v320c0 8.837-7.163 16-16 16H80c-8.837 0-16-7.163-16-16V144H16.016c-14.241 0-21.363-17.264-11.314-27.314zm301.671 98.621A12 12 0 0 1 294.838 224h-35.717c-8.22 0-14.007-8.078-11.362-15.861l57.096-168A12 12 0 0 1 316.217 32h39.566c5.139 0 9.708 3.273 11.362 8.139l57.096 168C426.886 215.922 421.1 224 412.879 224h-35.735a12 12 0 0 1-11.515-8.622l-8.301-28.299h-42.863l-8.092 28.228zm22.857-78.697h13.367l-6.6-22.937-6.767 22.937zm12.575 287.323l67.451-95.698a12 12 0 0 0 2.192-6.913V300c0-6.627-5.373-12-12-12H274.522c-6.627 0-12 5.373-12 12v28.93c0 6.627 5.373 12 12 12h56.469c-.739.991-1.497 2.036-2.27 3.133l-67.203 95.205a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h129.355c6.627 0 12-5.373 12-12v-28.93c0-6.627-5.373-12-12-12h-61.146c.74-.993 1.5-2.039 2.274-3.137z"
            })
        ]
    }));
};
/* harmony default export */ var SortAlphaUp = (SortAlphaUp_Icon);

;// CONCATENATED MODULE: ./units/Icon/Tag.tsx




var Tag_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Tag"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x1: "7",
                y1: "7",
                x2: "7.01",
                y2: "7"
            })
        ]
    }));
};
/* harmony default export */ var Tag = (Tag_Icon);

;// CONCATENATED MODULE: ./units/Icon/ToggleOn.tsx




var ToggleOn_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0.5 0 15 10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M10.05 0h-5c-2.76 0-5 2.24-5 5s2.24 5 5 5h5c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8.333A3.331 3.331 0 0 1 6.717 5a3.331 3.331 0 0 1 3.333-3.333A3.332 3.332 0 0 1 13.383 5a3.332 3.332 0 0 1-3.333 3.333z"
        })
    }));
};
/* harmony default export */ var ToggleOn = (ToggleOn_Icon);

;// CONCATENATED MODULE: ./units/Icon/ToggleOff.tsx




var ToggleOff_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0.167 16 10.667",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M10.6.5h-5a5 5 0 1 0 0 10h5a5 5 0 1 0 0-10zm-8.333 5A3.331 3.331 0 0 1 5.6 2.167 3.331 3.331 0 0 1 8.933 5.5 3.332 3.332 0 0 1 5.6 8.833 3.331 3.331 0 0 1 2.267 5.5zM10.6 8.833H9.326a4.998 4.998 0 0 0 0-6.666H10.6A3.332 3.332 0 0 1 13.933 5.5 3.332 3.332 0 0 1 10.6 8.833z"
        })
    }));
};
/* harmony default export */ var ToggleOff = (ToggleOff_Icon);

;// CONCATENATED MODULE: ./units/Icon/Undo.tsx




var Undo_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "14",
        viewBox: "0.081 0.138 15.684 13.723",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "scale(-1, 1)",
            "transform-origin": "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                paintOrder: "stroke fill markers",
                fillRule: "evenodd",
                d: "M7.923.138c2.165 0 4.126.878 5.545 2.298L15.765.138V6.02H9.884l2.198-2.198a5.882 5.882 0 1 0-8.049 8.57l-1.297 1.47A7.842 7.842 0 0 1 7.923.139z"
            })
        })
    }));
};
/* harmony default export */ var Undo = (Undo_Icon);

;// CONCATENATED MODULE: ./units/Icon/Upload.tsx




var Upload_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                points: "17 8 12 3 7 8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "12",
                y1: "3",
                x2: "12",
                y2: "15"
            })
        ]
    }));
};
/* harmony default export */ var Upload = (Upload_Icon);

;// CONCATENATED MODULE: ./units/Icon/Public.tsx




var Public_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Public"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
            })
        ]
    }));
};
/* harmony default export */ var Public = (Public_Icon);

;// CONCATENATED MODULE: ./units/Icon/Add.tsx




var Add_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Add"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
            })
        ]
    }));
};
/* harmony default export */ var Add = (Add_Icon);

;// CONCATENATED MODULE: ./units/Icon/Print.tsx




var Print = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
        })
    }));
};
/* harmony default export */ var Icon_Print = (Print);

;// CONCATENATED MODULE: ./units/Icon/Star.tsx




var Star_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Star"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M287.9 0C297.1 0 305.5 5.25 309.5 13.52L378.1 154.8L531.4 177.5C540.4 178.8 547.8 185.1 550.7 193.7C553.5 202.4 551.2 211.9 544.8 218.2L433.6 328.4L459.9 483.9C461.4 492.9 457.7 502.1 450.2 507.4C442.8 512.7 432.1 513.4 424.9 509.1L287.9 435.9L150.1 509.1C142.9 513.4 133.1 512.7 125.6 507.4C118.2 502.1 114.5 492.9 115.1 483.9L142.2 328.4L31.11 218.2C24.65 211.9 22.36 202.4 25.2 193.7C28.03 185.1 35.5 178.8 44.49 177.5L197.7 154.8L266.3 13.52C270.4 5.249 278.7 0 287.9 0L287.9 0zM287.9 78.95L235.4 187.2C231.9 194.3 225.1 199.3 217.3 200.5L98.98 217.9L184.9 303C190.4 308.5 192.9 316.4 191.6 324.1L171.4 443.7L276.6 387.5C283.7 383.7 292.2 383.7 299.2 387.5L404.4 443.7L384.2 324.1C382.9 316.4 385.5 308.5 391 303L476.9 217.9L358.6 200.5C350.7 199.3 343.9 194.3 340.5 187.2L287.9 78.95z"
            })
        ]
    }));
};
/* harmony default export */ var Star = (Star_Icon);

;// CONCATENATED MODULE: ./units/Icon/StarSolid.tsx




var StarSolid_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Star Solid"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
            })
        ]
    }));
};
/* harmony default export */ var StarSolid = (StarSolid_Icon);

;// CONCATENATED MODULE: ./units/Icon/Bars.tsx




var Bars_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 88C0 74.75 10.75 64 24 64H424C437.3 64 448 74.75 448 88C448 101.3 437.3 112 424 112H24C10.75 112 0 101.3 0 88zM0 248C0 234.7 10.75 224 24 224H424C437.3 224 448 234.7 448 248C448 261.3 437.3 272 424 272H24C10.75 272 0 261.3 0 248zM424 432H24C10.75 432 0 421.3 0 408C0 394.7 10.75 384 24 384H424C437.3 384 448 394.7 448 408C448 421.3 437.3 432 424 432z"
            })
        })
    }));
};
/* harmony default export */ var Bars = (Bars_Icon);

;// CONCATENATED MODULE: ./units/Icon/Xmark.tsx




var Xmark_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 320 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
            })
        })
    }));
};
/* harmony default export */ var Xmark = (Xmark_Icon);

;// CONCATENATED MODULE: ./units/Icon/GalleryThumbnails.tsx




var GalleryThumbnails_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 576 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M512 0C547.3 0 576 28.65 576 64V288C576 323.3 547.3 352 512 352H64C28.65 352 0 323.3 0 288V64C0 28.65 28.65 0 64 0H512zM512 48H64C55.16 48 48 55.16 48 64V288C48 296.8 55.16 304 64 304H512C520.8 304 528 296.8 528 288V64C528 55.16 520.8 48 512 48zM0 448C0 430.3 14.33 416 32 416H64C81.67 416 96 430.3 96 448V480C96 497.7 81.67 512 64 512H32C14.33 512 0 497.7 0 480V448zM224 416C241.7 416 256 430.3 256 448V480C256 497.7 241.7 512 224 512H192C174.3 512 160 497.7 160 480V448C160 430.3 174.3 416 192 416H224zM320 448C320 430.3 334.3 416 352 416H384C401.7 416 416 430.3 416 448V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V448zM544 416C561.7 416 576 430.3 576 448V480C576 497.7 561.7 512 544 512H512C494.3 512 480 497.7 480 480V448C480 430.3 494.3 416 512 416H544z"
            })
        })
    }));
};
/* harmony default export */ var GalleryThumbnails = (GalleryThumbnails_Icon);

;// CONCATENATED MODULE: ./units/Icon/Backpack.tsx




var Backpack_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M320 64h-16V48c0-26.47-21.53-48-48-48h-64c-26.47 0-48 21.53-48 48v16h-16C57.31 64 0 121.31 0 192v256c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V192c0-70.69-57.31-128-128-128zM176 48c0-8.83 7.19-16 16-16h64c8.81 0 16 7.17 16 16v16h-96V48zm160 432H112v-96h224v96zm0-128H112v-32c0-17.67 14.33-32 32-32h160c17.67 0 32 14.33 32 32v32zm80 96c0 17.64-14.36 32-32 32h-16V320c0-35.29-28.71-64-64-64H144c-35.29 0-64 28.71-64 64v160H64c-17.64 0-32-14.36-32-32V192c0-52.94 43.06-96 96-96h192c52.94 0 96 43.06 96 96v256zM312 160H136c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"
            })
        })
    }));
};
/* harmony default export */ var Backpack = (Backpack_Icon);

;// CONCATENATED MODULE: ./units/Icon/Book.tsx




var Book_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M356 160H188c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zm12 52v-8c0-6.6-5.4-12-12-12H188c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12zm64.7 268h3.3c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H80c-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0h344c13.3 0 24 10.7 24 24v368c0 10-6.2 18.6-14.9 22.2-3.6 16.1-4.4 45.6-.4 65.8zM128 384h288V32H128v352zm-96 16c13.4-10 30-16 48-16h16V32H80c-26.5 0-48 21.5-48 48v320zm372.3 80c-3.1-20.4-2.9-45.2 0-64H80c-64 0-64 64 0 64h324.3z"
            })
        })
    }));
};
/* harmony default export */ var Book = (Book_Icon);

;// CONCATENATED MODULE: ./units/Icon/Check.tsx




var Check_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
            })
        })
    }));
};
/* harmony default export */ var Check = (Check_Icon);

;// CONCATENATED MODULE: ./units/Icon/ExclamationMark.tsx




var ExclamationMark_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
            })
        })
    }));
};
/* harmony default export */ var ExclamationMark = (ExclamationMark_Icon);

;// CONCATENATED MODULE: ./units/Icon/Info.tsx




var Info_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm0-338c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
            })
        })
    }));
};
/* harmony default export */ var Info = (Info_Icon);

;// CONCATENATED MODULE: ./units/Icon/Warning.tsx




var Warning_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 496 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm176 296H72c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h352c8.84 0 16 7.16 16 16v64c0 8.84-7.16 16-16 16z"
            })
        })
    }));
};
/* harmony default export */ var Warning = (Warning_Icon);

;// CONCATENATED MODULE: ./units/Icon/Gear.tsx




var Gear_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M160 256C160 202.1 202.1 160 256 160C309 160 352 202.1 352 256C352 309 309 352 256 352C202.1 352 160 309 160 256zM256 208C229.5 208 208 229.5 208 256C208 282.5 229.5 304 256 304C282.5 304 304 282.5 304 256C304 229.5 282.5 208 256 208zM293.1 .0003C315.3 .0003 334.6 15.19 339.8 36.74L347.6 69.21C356.1 73.36 364.2 78.07 371.9 83.28L404 73.83C425.3 67.56 448.1 76.67 459.2 95.87L496.3 160.1C507.3 179.3 503.8 203.6 487.8 218.9L463.5 241.1C463.8 246.6 464 251.3 464 256C464 260.7 463.8 265.4 463.5 270L487.8 293.1C503.8 308.4 507.3 332.7 496.3 351.9L459.2 416.1C448.1 435.3 425.3 444.4 404 438.2L371.9 428.7C364.2 433.9 356.1 438.6 347.6 442.8L339.8 475.3C334.6 496.8 315.3 512 293.1 512H218.9C196.7 512 177.4 496.8 172.2 475.3L164.4 442.8C155.9 438.6 147.8 433.9 140.1 428.7L107.1 438.2C86.73 444.4 63.94 435.3 52.85 416.1L15.75 351.9C4.66 332.7 8.168 308.4 24.23 293.1L48.47 270C48.16 265.4 48 260.7 48 255.1C48 251.3 48.16 246.6 48.47 241.1L24.23 218.9C8.167 203.6 4.66 179.3 15.75 160.1L52.85 95.87C63.94 76.67 86.73 67.56 107.1 73.83L140.1 83.28C147.8 78.07 155.9 73.36 164.4 69.21L172.2 36.74C177.4 15.18 196.7 0 218.9 0L293.1 .0003zM205.5 103.6L194.3 108.3C181.6 113.6 169.8 120.5 159.1 128.7L149.4 136.1L94.42 119.9L57.31 184.1L98.81 223.6L97.28 235.6C96.44 242.3 96 249.1 96 256C96 262.9 96.44 269.7 97.28 276.4L98.81 288.4L57.32 327.9L94.42 392.1L149.4 375.9L159.1 383.3C169.8 391.5 181.6 398.4 194.3 403.7L205.5 408.4L218.9 464H293.1L306.5 408.4L317.7 403.7C330.4 398.4 342.2 391.5 352.9 383.3L362.6 375.9L417.6 392.1L454.7 327.9L413.2 288.4L414.7 276.4C415.6 269.7 416 262.9 416 256C416 249.1 415.6 242.3 414.7 235.6L413.2 223.6L454.7 184.1L417.6 119.9L362.6 136.1L352.9 128.7C342.2 120.5 330.4 113.6 317.7 108.3L306.5 103.6L293.1 48H218.9L205.5 103.6z"
            })
        })
    }));
};
/* harmony default export */ var Gear = (Gear_Icon);

;// CONCATENATED MODULE: ./units/Icon/ShareNodes.tsx




var ShareNodes_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M448 112C448 156.2 412.2 192 368 192C345.1 192 324.4 182.4 309.9 166.1L158.9 242.5C159.6 246.9 160 251.4 160 256C160 260.6 159.6 265.1 158.9 269.5L309.9 345C324.4 329.6 345.1 320 368 320C412.2 320 448 355.8 448 400C448 444.2 412.2 480 368 480C323.8 480 288 444.2 288 400C288 390.3 289.7 380.1 292.9 372.3L147.2 299.5C132.9 321.5 108.2 336 80 336C35.82 336 0 300.2 0 256C0 211.8 35.82 176 80 176C108.2 176 132.9 190.5 147.2 212.5L292.9 139.7C289.7 131 288 121.7 288 112C288 67.82 323.8 32 368 32C412.2 32 448 67.82 448 112L448 112zM79.1 304C106.5 304 127.1 282.5 127.1 256C127.1 229.5 106.5 208 79.1 208C53.49 208 31.1 229.5 31.1 256C31.1 282.5 53.49 304 79.1 304zM368 64C341.5 64 320 85.49 320 112C320 138.5 341.5 160 368 160C394.5 160 416 138.5 416 112C416 85.49 394.5 64 368 64zM368 448C394.5 448 416 426.5 416 400C416 373.5 394.5 352 368 352C341.5 352 320 373.5 320 400C320 426.5 341.5 448 368 448z"
            })
        })
    }));
};
/* harmony default export */ var ShareNodes = (ShareNodes_Icon);

;// CONCATENATED MODULE: ./units/Icon/CameraViewFinder.tsx




var CameraViewFinder_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 48C0 21.49 21.49 0 48 0H144C152.8 0 160 7.164 160 16C160 24.84 152.8 32 144 32H48C39.16 32 32 39.16 32 48V144C32 152.8 24.84 160 16 160C7.164 160 0 152.8 0 144V48zM320 256C320 291.3 291.3 320 256 320C220.7 320 192 291.3 192 256C192 220.7 220.7 192 256 192C291.3 192 320 220.7 320 256zM256 224C238.3 224 224 238.3 224 256C224 273.7 238.3 288 256 288C273.7 288 288 273.7 288 256C288 238.3 273.7 224 256 224zM325.8 111.6L332 128H360C390.9 128 416 153.1 416 184V328C416 358.9 390.9 384 360 384H152C121.1 384 96 358.9 96 328V184C96 153.1 121.1 128 152 128H180L186.2 111.6C189.7 102.2 198.6 96 208.6 96H303.4C313.4 96 322.3 102.2 325.8 111.6zM152 160C138.7 160 128 170.7 128 184V328C128 341.3 138.7 352 152 352H360C373.3 352 384 341.3 384 328V184C384 170.7 373.3 160 360 160H309.8L297.8 128H214.2L202.2 160H152zM464 0C490.5 0 512 21.49 512 48V144C512 152.8 504.8 160 496 160C487.2 160 480 152.8 480 144V48C480 39.16 472.8 32 464 32H368C359.2 32 352 24.84 352 16C352 7.164 359.2 0 368 0H464zM0 368C0 359.2 7.164 352 16 352C24.84 352 32 359.2 32 368V464C32 472.8 39.16 480 48 480H144C152.8 480 160 487.2 160 496C160 504.8 152.8 512 144 512H48C21.49 512 0 490.5 0 464V368zM368 512C359.2 512 352 504.8 352 496C352 487.2 359.2 480 368 480H464C472.8 480 480 472.8 480 464V368C480 359.2 487.2 352 496 352C504.8 352 512 359.2 512 368V464C512 490.5 490.5 512 464 512H368z"
            })
        })
    }));
};
/* harmony default export */ var CameraViewFinder = (CameraViewFinder_Icon);

;// CONCATENATED MODULE: ./units/Icon/index.ts













































var collection = {
    ArrowDown: ArrowDown,
    ArrowUp: ArrowUp,
    ArrowRight: ArrowRight,
    ChevronDown: ChevronDown,
    ChevronLeft: ChevronLeft,
    ChevronRight: ChevronRight,
    Close: Close,
    ColorPalette: ColorPalette,
    Droplet: Droplet,
    Edit: Edit,
    ExpandArrowsAlt: ExpandArrowsAlt,
    Filter: Filter,
    Image: Image,
    Layout: Layout,
    Loading: Loading,
    Lock: Lock,
    MetroShrink: MetroShrink,
    Redo: Redo,
    Resize: Resize,
    Ruler: Ruler,
    Search: Search,
    SortAlphaDown: SortAlphaDown,
    SortAlphaUp: SortAlphaUp,
    Tag: Tag,
    ToggleOn: ToggleOn,
    ToggleOff: ToggleOff,
    Undo: Undo,
    Upload: Upload,
    Public: Public,
    Add: Add,
    Print: Icon_Print,
    Star: Star,
    StarSolid: StarSolid,
    Bars: Bars,
    Xmark: Xmark,
    Check: Check,
    ExclamationMark: ExclamationMark,
    Info: Info,
    Warning: Warning,
    Gear: Gear,
    ShareNodes: ShareNodes,
    CameraViewFinder: CameraViewFinder,
    Book: Book,
    Backpack: Backpack,
    GalleryThumbnails: GalleryThumbnails
};
/* harmony default export */ var units_Icon = (collection);


/***/ })

}]);